/* eslint-disable */
// @ts-nocheck
const value: any =
[
    {
      "id": 15,
      "name": "Queensdale",
      "min_level": 1,
      "max_level": 15,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        65,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 17,
      "name": "Harathi Hinterlands",
      "min_level": 35,
      "max_level": 45,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        65,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          46208,
          25856
        ],
        [
          49408,
          28672
        ]
      ]
    },
    {
      "id": 18,
      "name": "Divinity's Reach",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        65,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 19,
      "name": "Plains of Ashford",
      "min_level": 1,
      "max_level": 15,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 20,
      "name": "Blazeridge Steppes",
      "min_level": 40,
      "max_level": 50,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          61952,
          28544
        ],
        [
          64000,
          32640
        ]
      ]
    },
    {
      "id": 21,
      "name": "Fields of Ruin",
      "min_level": 30,
      "max_level": 40,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          61440,
          32640
        ],
        [
          64512,
          35712
        ]
      ]
    },
    {
      "id": 22,
      "name": "Fireheart Rise",
      "min_level": 60,
      "max_level": 70,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          56576,
          24832
        ],
        [
          59904,
          27648
        ]
      ]
    },
    {
      "id": 23,
      "name": "Kessex Hills",
      "min_level": 15,
      "max_level": 25,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        57,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 24,
      "name": "Gendarran Fields",
      "min_level": 25,
      "max_level": 35,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 25,
      "name": "Iron Marches",
      "min_level": 50,
      "max_level": 60,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        67,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          59904,
          25856
        ],
        [
          61952,
          29952
        ]
      ]
    },
    {
      "id": 26,
      "name": "Dredgehaunt Cliffs",
      "min_level": 40,
      "max_level": 50,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          52224,
          31360
        ],
        [
          54528,
          34560
        ]
      ]
    },
    {
      "id": 27,
      "name": "Lornar's Pass",
      "min_level": 25,
      "max_level": 40,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 28,
      "name": "Wayfarer Foothills",
      "min_level": 1,
      "max_level": 15,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        58,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 29,
      "name": "Timberline Falls",
      "min_level": 50,
      "max_level": 60,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          51712,
          34560
        ],
        [
          54016,
          37760
        ]
      ]
    },
    {
      "id": 30,
      "name": "Frostgorge Sound",
      "min_level": 70,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          53504,
          24576
        ],
        [
          56576,
          27648
        ]
      ]
    },
    {
      "id": 31,
      "name": "Snowden Drifts",
      "min_level": 15,
      "max_level": 25,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 32,
      "name": "Diessa Plateau",
      "min_level": 15,
      "max_level": 25,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          27648
        ]
      ],
      "continent_rect": [
        [
          56320,
          27648
        ],
        [
          59904,
          29952
        ]
      ]
    },
    {
      "id": 33,
      "name": "Ascalonian Catacombs",
      "min_level": 30,
      "max_level": 32,
      "default_floor": -2,
      "type": "Instance",
      "floors": [
        -2
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -12288
        ],
        [
          15360,
          12288
        ]
      ],
      "continent_rect": [
        [
          60416,
          29440
        ],
        [
          61696,
          30464
        ]
      ]
    },
    {
      "id": 34,
      "name": "Caledon Forest",
      "min_level": 1,
      "max_level": 15,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 35,
      "name": "Metrica Province",
      "min_level": 1,
      "max_level": 15,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        56,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 36,
      "name": "Ascalonian Catacombs",
      "min_level": 35,
      "max_level": 35,
      "default_floor": -2,
      "type": "Instance",
      "floors": [
        -2
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -12288
        ],
        [
          15360,
          12288
        ]
      ],
      "continent_rect": [
        [
          60416,
          29440
        ],
        [
          61696,
          30464
        ]
      ]
    },
    {
      "id": 37,
      "name": "Arson at the Orphanage",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 38,
      "name": "Eternal Battlegrounds",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 3,
      "type": "Center",
      "floors": [
        1,
        3
      ],
      "region_id": 7,
      "region_name": "World vs. World",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          8958,
          12798
        ],
        [
          12030,
          15870
        ]
      ]
    },
    {
      "id": 39,
      "name": "Mount Maelstrom",
      "min_level": 60,
      "max_level": 70,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 50,
      "name": "Lion's Arch",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        2,
        0,
        64,
        3,
        66
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 51,
      "name": "Straits of Devastation",
      "min_level": 70,
      "max_level": 75,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 53,
      "name": "Sparkfly Fen",
      "min_level": 55,
      "max_level": 65,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -39936
        ],
        [
          30720,
          39936
        ]
      ],
      "continent_rect": [
        [
          48000,
          35456
        ],
        [
          50560,
          38784
        ]
      ]
    },
    {
      "id": 54,
      "name": "Brisban Wildlands",
      "min_level": 15,
      "max_level": 25,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        56,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 55,
      "name": "The Hospital in Jeopardy",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 61,
      "name": "Infiltration",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 62,
      "name": "Cursed Shore",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42880,
          41600
        ],
        [
          44928,
          45696
        ]
      ]
    },
    {
      "id": 63,
      "name": "Sorrow's Embrace",
      "min_level": 60,
      "max_level": 62,
      "default_floor": -7,
      "type": "Instance",
      "floors": [
        -7
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -18432
        ],
        [
          18432,
          18432
        ]
      ],
      "continent_rect": [
        [
          52096,
          33792
        ],
        [
          53632,
          35328
        ]
      ]
    },
    {
      "id": 64,
      "name": "Sorrow's Embrace",
      "min_level": 65,
      "max_level": 65,
      "default_floor": -7,
      "type": "Instance",
      "floors": [
        -7
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -18432
        ],
        [
          18432,
          18432
        ]
      ],
      "continent_rect": [
        [
          52096,
          33792
        ],
        [
          53632,
          35328
        ]
      ]
    },
    {
      "id": 65,
      "name": "Malchor's Leap",
      "min_level": 75,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          43136,
          39552
        ],
        [
          47232,
          41600
        ]
      ]
    },
    {
      "id": 66,
      "name": "Citadel of Flame",
      "min_level": 70,
      "max_level": 72,
      "default_floor": -10,
      "type": "Instance",
      "floors": [
        -10
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          59392,
          24064
        ],
        [
          60672,
          25344
        ]
      ]
    },
    {
      "id": 67,
      "name": "Twilight Arbor",
      "min_level": 55,
      "max_level": 80,
      "default_floor": -9,
      "type": "Instance",
      "floors": [
        -5,
        -9
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -12288
        ],
        [
          15360,
          12288
        ]
      ],
      "continent_rect": [
        [
          41472,
          32384
        ],
        [
          42752,
          33408
        ]
      ]
    },
    {
      "id": 68,
      "name": "Twilight Arbor",
      "min_level": 50,
      "max_level": 52,
      "default_floor": -6,
      "type": "Instance",
      "floors": [
        -6
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -12288
        ],
        [
          15360,
          12288
        ]
      ],
      "continent_rect": [
        [
          41472,
          32384
        ],
        [
          42752,
          33408
        ]
      ]
    },
    {
      "id": 69,
      "name": "Citadel of Flame",
      "min_level": 75,
      "max_level": 75,
      "default_floor": -10,
      "type": "Instance",
      "floors": [
        -10
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          59392,
          24064
        ],
        [
          60672,
          25344
        ]
      ]
    },
    {
      "id": 70,
      "name": "Honor of the Waves",
      "min_level": 76,
      "max_level": 78,
      "default_floor": 8,
      "type": "Instance",
      "floors": [
        7,
        6,
        8
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -12288
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          54528,
          24448
        ],
        [
          55808,
          25600
        ]
      ]
    },
    {
      "id": 71,
      "name": "Honor of the Waves",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 8,
      "type": "Instance",
      "floors": [
        7,
        6,
        8
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -12288
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          54528,
          24448
        ],
        [
          55808,
          25600
        ]
      ]
    },
    {
      "id": 73,
      "name": "Bloodtide Coast",
      "min_level": 45,
      "max_level": 55,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          30720,
          39936
        ]
      ],
      "continent_rect": [
        [
          48000,
          32256
        ],
        [
          50432,
          35456
        ]
      ]
    },
    {
      "id": 75,
      "name": "Caudecus's Manor",
      "min_level": 40,
      "max_level": 42,
      "default_floor": 4,
      "type": "Instance",
      "floors": [
        5,
        -4,
        4
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          45184,
          27776
        ],
        [
          46208,
          28800
        ]
      ]
    },
    {
      "id": 76,
      "name": "Caudecus's Manor",
      "min_level": 45,
      "max_level": 45,
      "default_floor": 4,
      "type": "Instance",
      "floors": [
        5,
        -4,
        4
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          45184,
          27776
        ],
        [
          46208,
          28800
        ]
      ]
    },
    {
      "id": 77,
      "name": "Search the Premises",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 79,
      "name": "The Informant",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 80,
      "name": "A Society Function",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 81,
      "name": "Crucible of Eternity",
      "min_level": 78,
      "max_level": 80,
      "default_floor": -11,
      "type": "Instance",
      "floors": [
        -11
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -15360
        ],
        [
          12288,
          15360
        ]
      ],
      "continent_rect": [
        [
          53184,
          37696
        ],
        [
          54208,
          38976
        ]
      ]
    },
    {
      "id": 82,
      "name": "Crucible of Eternity",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -11,
      "type": "Instance",
      "floors": [
        -11
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -15360
        ],
        [
          12288,
          15360
        ]
      ],
      "continent_rect": [
        [
          53184,
          37696
        ],
        [
          54208,
          38976
        ]
      ]
    },
    {
      "id": 89,
      "name": "Chasing the Culprits",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 91,
      "name": "The Grove",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 92,
      "name": "The Trial of Julius Zamon",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 95,
      "name": " Alpine Borderlands",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 3,
      "type": "GreenHome",
      "floors": [
        1,
        3
      ],
      "region_id": 7,
      "region_name": "World vs. World",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -30720,
          -43008
        ],
        [
          30720,
          43008
        ]
      ],
      "continent_rect": [
        [
          5630,
          11518
        ],
        [
          8190,
          15102
        ]
      ]
    },
    {
      "id": 96,
      "name": " Alpine Borderlands",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 3,
      "type": "BlueHome",
      "floors": [
        1,
        3
      ],
      "region_id": 7,
      "region_name": "World vs. World",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -30720,
          -43008
        ],
        [
          30720,
          43008
        ]
      ],
      "continent_rect": [
        [
          12798,
          10878
        ],
        [
          15358,
          14462
        ]
      ]
    },
    {
      "id": 97,
      "name": "Infiltration",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 110,
      "name": "The Perils of Friendship",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 111,
      "name": "Victory or Death",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 10,
      "type": "Instance",
      "floors": [
        11,
        10
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          44928,
          43520
        ],
        [
          48256,
          46336
        ]
      ]
    },
    {
      "id": 112,
      "name": "The Ruined City of Arah",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 9,
      "type": "Instance",
      "floors": [
        9
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -24576
        ],
        [
          24576,
          24576
        ]
      ],
      "continent_rect": [
        [
          44928,
          42880
        ],
        [
          46976,
          44928
        ]
      ]
    },
    {
      "id": 113,
      "name": "Desperate Medicine",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 120,
      "name": "The Commander",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 138,
      "name": "Defense of Shaemoor",
      "min_level": 1,
      "max_level": 1,
      "default_floor": 1,
      "type": "Tutorial",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 139,
      "name": "Rata Sum",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        55,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 140,
      "name": "The Apothecary",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 142,
      "name": "Going Undercover",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 143,
      "name": "Going Undercover",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 144,
      "name": "The Greater Good",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 145,
      "name": "The Rescue",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 147,
      "name": "Breaking the Blade",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 148,
      "name": "The Fall of Falcon Company",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 149,
      "name": "The Fall of Falcon Company",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 152,
      "name": "Confronting Captain Tervelan",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 153,
      "name": "Seek Logan's Aid",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 154,
      "name": "Seek Logan's Aid",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 157,
      "name": "Accusation",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 159,
      "name": "Accusation",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 161,
      "name": "Liberation",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 162,
      "name": "Voices From the Past",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 163,
      "name": "Voices From the Past",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 171,
      "name": "Rending the Mantle",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 172,
      "name": "Rending the Mantle",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 178,
      "name": "The Floating Grizwhirl",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 179,
      "name": "The Floating Grizwhirl",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 180,
      "name": "The Floating Grizwhirl",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 182,
      "name": "Clown College",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 184,
      "name": "The Artist's Workshop",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 185,
      "name": "Into the Woods",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 186,
      "name": "The Ringmaster",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 190,
      "name": "The Orders of Tyria",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 191,
      "name": "The Orders of Tyria",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 192,
      "name": "Brute Force",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 193,
      "name": "Mortus Virge",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 195,
      "name": "Triskell Quay",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 196,
      "name": "Track the Seraph",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 198,
      "name": "Speaker of the Dead",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 199,
      "name": "The Sad Tale of the \"Ravenous\"",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 201,
      "name": "Kellach's Attack",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 202,
      "name": "The Queen's Justice",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 203,
      "name": "The Trap",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 211,
      "name": "Best Laid Plans",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 212,
      "name": "Welcome Home",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 215,
      "name": "The Tribune's Call",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 216,
      "name": "The Tribune's Call",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 217,
      "name": "The Tribune's Call",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 218,
      "name": "Black Citadel",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 222,
      "name": "A Spy for a Spy",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 224,
      "name": "Scrapyard Dogs",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 225,
      "name": "A Spy for a Spy",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 226,
      "name": "On the Mend",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 232,
      "name": "Spilled Blood",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 234,
      "name": "Ghostbore Musket",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 237,
      "name": "Iron Grip of the Legion",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 238,
      "name": "The Flame Advances",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 239,
      "name": "The Flame Advances",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 242,
      "name": "Test Your Metal",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 244,
      "name": "Quick and Quiet",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 248,
      "name": "Salma District (Home)",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 249,
      "name": "An Unusual Inheritance",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 250,
      "name": "Windrock Maze",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 251,
      "name": "Mired Deep",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 252,
      "name": "Mired Deep",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 254,
      "name": "Deadly Force",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 255,
      "name": "Ghostbore Artillery",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 256,
      "name": "No Negotiations",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          27648
        ]
      ],
      "continent_rect": [
        [
          56320,
          27648
        ],
        [
          59904,
          29952
        ]
      ]
    },
    {
      "id": 257,
      "name": "Salvaging Scrap",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          27648
        ]
      ],
      "continent_rect": [
        [
          56320,
          27648
        ],
        [
          59904,
          29952
        ]
      ]
    },
    {
      "id": 258,
      "name": "Salvaging Scrap",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          27648
        ]
      ],
      "continent_rect": [
        [
          56320,
          27648
        ],
        [
          59904,
          29952
        ]
      ]
    },
    {
      "id": 259,
      "name": "In the Ruins",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 260,
      "name": "In the Ruins",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          27648
        ]
      ],
      "continent_rect": [
        [
          56320,
          27648
        ],
        [
          59904,
          29952
        ]
      ]
    },
    {
      "id": 262,
      "name": "Chain of Command",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 263,
      "name": "Chain of Command",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 264,
      "name": "Time for a Promotion",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 267,
      "name": "The End of the Line",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 269,
      "name": "Magic Users",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 271,
      "name": "Rage Suppression",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 272,
      "name": "Rage Suppression",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 274,
      "name": "Operation: Bulwark",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 275,
      "name": "AWOL",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 276,
      "name": "Human's Lament",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 282,
      "name": "Misplaced Faith",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          27648
        ]
      ],
      "continent_rect": [
        [
          56320,
          27648
        ],
        [
          59904,
          29952
        ]
      ]
    },
    {
      "id": 283,
      "name": "Thicker Than Water",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 284,
      "name": "Dishonorable Discharge",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 287,
      "name": "Searching for the Truth",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 288,
      "name": "Lighting the Beacons",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 290,
      "name": "Stoking the Flame",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 294,
      "name": "A Fork in the Road",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          27648
        ]
      ],
      "continent_rect": [
        [
          56320,
          27648
        ],
        [
          59904,
          29952
        ]
      ]
    },
    {
      "id": 295,
      "name": "Sins of the Father",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 297,
      "name": "Graveyard Ornaments",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 326,
      "name": "Hoelbrak",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        58,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 327,
      "name": "Desperate Medicine",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 330,
      "name": "Seraph Headquarters",
      "min_level": 0,
      "max_level": 15,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 334,
      "name": "Keg Brawl",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Pvp",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 335,
      "name": "Claw Island",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -18432
        ],
        [
          18432,
          18432
        ]
      ],
      "continent_rect": [
        [
          46720,
          32256
        ],
        [
          48256,
          33792
        ]
      ]
    },
    {
      "id": 336,
      "name": "Chantry of Secrets",
      "min_level": 45,
      "max_level": 55,
      "default_floor": -3,
      "type": "Instance",
      "floors": [
        -3,
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          48768,
          32384
        ],
        [
          49792,
          33408
        ]
      ]
    },
    {
      "id": 350,
      "name": "Heart of the Mists",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          4865,
          6398
        ],
        [
          6145,
          7678
        ]
      ]
    },
    {
      "id": 363,
      "name": "The Sting",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 364,
      "name": "Drawing Out the Cult",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 365,
      "name": "Ashes of the Past",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 371,
      "name": "Hero's Canton (Home)",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 372,
      "name": "Blood Tribune Quarters",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 373,
      "name": "The Command Core",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 374,
      "name": "Knut Whitebear's Loft",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 375,
      "name": "Hunter's Hearth (Home)",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 376,
      "name": "Stonewright's Steading",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 378,
      "name": "Queen's Throne Room",
      "min_level": 0,
      "max_level": 15,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 379,
      "name": "The Great Hunt",
      "min_level": 1,
      "max_level": 1,
      "default_floor": 1,
      "type": "Tutorial",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 380,
      "name": "A Weapon of Legend",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 381,
      "name": "The Last of the Giant-Kings",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 382,
      "name": "Disciples of the Dragon",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 385,
      "name": "A Weapon of Legend",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 386,
      "name": "Echoes of Ages Past",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 387,
      "name": "Wild Spirits",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 388,
      "name": "Out of the Skies",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 389,
      "name": "Echoes of Ages Past",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 390,
      "name": "Twilight of the Wolf",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 391,
      "name": "Rage of the Minotaurs",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 392,
      "name": "A Pup's Illness",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 393,
      "name": "Through the Veil",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 394,
      "name": "A Trap Foiled",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 396,
      "name": "Raven's Revered",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 397,
      "name": "One Good Drink Deserves Another",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 399,
      "name": "Shape of the Spirit",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 400,
      "name": "Into the Mists",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 401,
      "name": "Through the Veil",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 405,
      "name": "Blessed of Bear",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 407,
      "name": "The Wolf Havroun",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 410,
      "name": "Minotaur Rampant",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 411,
      "name": "Minotaur Rampant",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 412,
      "name": "Unexpected Visitors",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 413,
      "name": "Rumors of Trouble",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 414,
      "name": "A New Challenger",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 415,
      "name": "Unexpected Visitors",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 416,
      "name": "Roadblock",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          27648
        ]
      ],
      "continent_rect": [
        [
          56320,
          27648
        ],
        [
          59904,
          29952
        ]
      ]
    },
    {
      "id": 417,
      "name": "Assault on Moledavia",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          27648
        ]
      ],
      "continent_rect": [
        [
          56320,
          27648
        ],
        [
          59904,
          29952
        ]
      ]
    },
    {
      "id": 418,
      "name": "Don't Leave Your Toys Out",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 419,
      "name": "A New Challenger",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 420,
      "name": "First Attack",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 421,
      "name": "The Finishing Blow",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 422,
      "name": "The Semifinals",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          27648
        ]
      ],
      "continent_rect": [
        [
          56320,
          27648
        ],
        [
          59904,
          29952
        ]
      ]
    },
    {
      "id": 423,
      "name": "The Championship Fight",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 424,
      "name": "The Championship Fight",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 425,
      "name": "The Machine in Action",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          27648
        ]
      ],
      "continent_rect": [
        [
          56320,
          27648
        ],
        [
          59904,
          29952
        ]
      ]
    },
    {
      "id": 427,
      "name": "Among the Kodan",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 428,
      "name": "Rumors of Trouble",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 429,
      "name": "Rage of the Minotaurs",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 430,
      "name": "Darkness at Drakentelt",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 432,
      "name": "Fighting the Nightmare",
      "min_level": 1,
      "max_level": 1,
      "default_floor": -15,
      "type": "Tutorial",
      "floors": [
        -15
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 434,
      "name": "Preserving the Balance",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 435,
      "name": "Means to an End",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 436,
      "name": "Dredge Technology",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 439,
      "name": "Underground Scholar",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 440,
      "name": "Dredge Assault",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 441,
      "name": "The Dredge Hideout",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 444,
      "name": "Sabotage",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 447,
      "name": "Codebreaker",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 449,
      "name": "Armaments",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 453,
      "name": "Assault the Hill",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 454,
      "name": "Silent Warfare",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 455,
      "name": "Sever the Head",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 458,
      "name": "Fury of the Dead",
      "min_level": 1,
      "max_level": 1,
      "default_floor": 1,
      "type": "Tutorial",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 459,
      "name": "A Fork in the Road",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 460,
      "name": "Citadel Stockade",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 464,
      "name": "Tribunes in Effigy",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 465,
      "name": "Sins of the Father",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 466,
      "name": "Misplaced Faith",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 470,
      "name": "Graveyard Ornaments",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 471,
      "name": "Undead Infestation",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 474,
      "name": "Whispers in the Dark",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 476,
      "name": "Dangerous Research",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 477,
      "name": "Digging Up Answers",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 480,
      "name": "Defending the Keep",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 481,
      "name": "Undead Detection",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 483,
      "name": "Ever Vigilant",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 485,
      "name": "Research and Destroy",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 487,
      "name": "Whispers of Vengeance",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 488,
      "name": "Killer Instinct",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          61440,
          32640
        ],
        [
          64512,
          35712
        ]
      ]
    },
    {
      "id": 489,
      "name": "Meeting my Mentor",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 490,
      "name": "A Fragile Peace",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          61440,
          32640
        ],
        [
          64512,
          35712
        ]
      ]
    },
    {
      "id": 492,
      "name": "Don't Shoot the Messenger",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          61440,
          32640
        ],
        [
          64512,
          35712
        ]
      ]
    },
    {
      "id": 496,
      "name": "Meeting my Mentor",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 497,
      "name": "Dredging Up the Past",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 498,
      "name": "Dredging Up the Past",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 499,
      "name": "Scrapyard Dogs",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 502,
      "name": "Quaestor's Siege",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          61440,
          32640
        ],
        [
          64512,
          35712
        ]
      ]
    },
    {
      "id": 503,
      "name": "Minister's Defense",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          61440,
          32640
        ],
        [
          64512,
          35712
        ]
      ]
    },
    {
      "id": 504,
      "name": "Called to Service",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 505,
      "name": "Called to Service",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 507,
      "name": "Mockery of Death",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 509,
      "name": "Discovering Darkness",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 511,
      "name": "Hounds and the Hunted",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 512,
      "name": "Hounds and the Hunted",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 513,
      "name": "Loved and Lost",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 514,
      "name": "Saving the Stag",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 515,
      "name": "Hidden in Darkness",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 516,
      "name": "Good Work Spoiled",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 517,
      "name": "Black Night, White Stag",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 518,
      "name": "The Omphalos Chamber",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 519,
      "name": "Weakness of the Heart",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 520,
      "name": "Awakening",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 521,
      "name": "Holding Back the Darkness",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 522,
      "name": "A Sly Trick",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 523,
      "name": "Deep Tangled Roots",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 524,
      "name": "The Heart of Nightmare",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 525,
      "name": "Beneath a Cold Moon",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 527,
      "name": "The Knight's Duel",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 528,
      "name": "Hammer and Steel",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 529,
      "name": "Where Life Goes",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 532,
      "name": "After the Storm",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 533,
      "name": "After the Storm",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 534,
      "name": "Beneath the Waves",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 535,
      "name": "Mirror, Mirror",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 536,
      "name": "A Vision of Darkness",
      "min_level": 20,
      "max_level": 20,
      "default_floor": -16,
      "type": "Instance",
      "floors": [
        1,
        -16,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -33792,
          -24576
        ],
        [
          33792,
          24576
        ]
      ],
      "continent_rect": [
        [
          41088,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 537,
      "name": "Shattered Light",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 538,
      "name": "An Unknown Soul",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 539,
      "name": "An Unknown Soul",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 540,
      "name": "Where Life Goes",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 542,
      "name": "Source of the Issue",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 543,
      "name": "Wild Growth",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 544,
      "name": "Wild Growth",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 545,
      "name": "Seeking the Zalisco",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 546,
      "name": "The Direct Approach",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 547,
      "name": "Trading Trickery",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 548,
      "name": "Eye of the Sun",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 549,
      "name": "Battle of Kyhlo",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 6,
      "type": "Pvp",
      "floors": [
        1,
        6
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          3326,
          5374
        ],
        [
          4094,
          6142
        ]
      ]
    },
    {
      "id": 552,
      "name": "Seeking the Zalisco",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 554,
      "name": "Forest of Niflhel",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 5,
      "type": "Pvp",
      "floors": [
        1,
        5
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -12288,
          -6144
        ],
        [
          12288,
          9216
        ]
      ],
      "continent_rect": [
        [
          7038,
          4860
        ],
        [
          8062,
          5500
        ]
      ]
    },
    {
      "id": 556,
      "name": "A Different Dream",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 557,
      "name": "A Splinter in the Flesh",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 558,
      "name": "Shadow of the Tree",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 559,
      "name": "Eye of the Sun",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 560,
      "name": "Sharpened Thorns",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 561,
      "name": "Bramble Walls",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 563,
      "name": "Secrets in the Earth",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 564,
      "name": "The Blossom of Youth",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 566,
      "name": "The Bad Apple",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 567,
      "name": "Trouble at the Roots",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 569,
      "name": "Flower of Death",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 570,
      "name": "Dead of Winter",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 571,
      "name": "A Tangle of Weeds",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 573,
      "name": "Explosive Intellect",
      "min_level": 1,
      "max_level": 1,
      "default_floor": 1,
      "type": "Tutorial",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 574,
      "name": "In Snaff's Footsteps",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 575,
      "name": "Golem Positioning System",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 576,
      "name": "Monkey Wrench",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 577,
      "name": "Defusing the Problem",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 578,
      "name": "The Things We Do For Love",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 579,
      "name": "The Snaff Prize",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 581,
      "name": "A Sparkling Rescue",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 582,
      "name": "High Maintenance",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 583,
      "name": "Snaff Would Be Proud",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 584,
      "name": "Taking Credit Back",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 586,
      "name": "Political Homicide",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 587,
      "name": "Here, There, Everywhere",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 588,
      "name": "Piece Negotiations",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 589,
      "name": "Readings On the Rise",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 590,
      "name": "Snaff Would Be Proud",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 591,
      "name": "Readings On the Rise",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 592,
      "name": "Unscheduled Delay",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 594,
      "name": "Stand By Your Krewe",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 595,
      "name": "Unwelcome Visitors",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 596,
      "name": "Where Credit Is Due",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 597,
      "name": "Where Credit Is Due",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 598,
      "name": "Short Fuse",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 599,
      "name": "Short Fuse",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 606,
      "name": "Salt in the Wound",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 607,
      "name": "Free Rein",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 608,
      "name": "Serving Up Trouble",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 609,
      "name": "Serving Up Trouble",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 610,
      "name": "Flash Flood",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 611,
      "name": "I Smell a Rat",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 613,
      "name": "Magnum Opus",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 614,
      "name": "Magnum Opus",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 617,
      "name": "Bad Business",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 618,
      "name": "Beta Test",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 619,
      "name": "Beta Test",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 620,
      "name": "Any Sufficiently Advanced Science",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 621,
      "name": "Any Sufficiently Advanced Science",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 622,
      "name": "Bad Forecast",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 623,
      "name": "Industrial Espionage",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 624,
      "name": "Split Second",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 625,
      "name": "Carry a Big Stick",
      "min_level": 20,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 627,
      "name": "Meeting my Mentor",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 628,
      "name": "Stealing Secrets",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 629,
      "name": "A Bold New Theory",
      "min_level": 30,
      "max_level": 35,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 630,
      "name": "Forging Permission",
      "min_level": 30,
      "max_level": 35,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 631,
      "name": "Forging Permission",
      "min_level": 30,
      "max_level": 35,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 633,
      "name": "Setting the Stage",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 634,
      "name": "Containment",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 635,
      "name": "Containment",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 636,
      "name": "Hazardous Environment",
      "min_level": 30,
      "max_level": 35,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 638,
      "name": "Down the Hatch",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 639,
      "name": "Down the Hatch",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 642,
      "name": "The Stone Sheath",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 643,
      "name": "Bad Blood",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 644,
      "name": "Test Subject",
      "min_level": 30,
      "max_level": 35,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 645,
      "name": "Field Test",
      "min_level": 30,
      "max_level": 35,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 646,
      "name": "The House of Caithe",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 3,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 647,
      "name": "Dreamer's Terrace (Home)",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 3,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 648,
      "name": "The Omphalos Chamber",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 649,
      "name": "Snaff Memorial Lab",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 650,
      "name": "Applied Development Lab (Home)",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 651,
      "name": "Council Level",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 652,
      "name": "A Meeting of the Minds",
      "min_level": 30,
      "max_level": 35,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 653,
      "name": "Mightier than the Sword",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 654,
      "name": "They Went Thataway",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 655,
      "name": "Lines of Communication",
      "min_level": 30,
      "max_level": 35,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 656,
      "name": "Untamed Wilds",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          61952,
          28544
        ],
        [
          64000,
          32640
        ]
      ]
    },
    {
      "id": 657,
      "name": "An Apple a Day",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          30720,
          39936
        ]
      ],
      "continent_rect": [
        [
          48000,
          32256
        ],
        [
          50432,
          35456
        ]
      ]
    },
    {
      "id": 658,
      "name": "Base of Operations",
      "min_level": 40,
      "max_level": 40,
      "default_floor": -3,
      "type": "Instance",
      "floors": [
        -3,
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          48768,
          32384
        ],
        [
          49792,
          33408
        ]
      ]
    },
    {
      "id": 659,
      "name": "The Lost Chieftain's Return",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          61952,
          28544
        ],
        [
          64000,
          32640
        ]
      ]
    },
    {
      "id": 660,
      "name": "Thrown Off Guard",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 662,
      "name": "Pets and Walls Make Stronger Kraals",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          61952,
          28544
        ],
        [
          64000,
          32640
        ]
      ]
    },
    {
      "id": 663,
      "name": "Doubt",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          52224,
          31360
        ],
        [
          54528,
          34560
        ]
      ]
    },
    {
      "id": 664,
      "name": "The False God's Lair",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          52224,
          31360
        ],
        [
          54528,
          34560
        ]
      ]
    },
    {
      "id": 666,
      "name": "Bad Ice",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          52224,
          31360
        ],
        [
          54528,
          34560
        ]
      ]
    },
    {
      "id": 667,
      "name": "Bad Ice",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          52224,
          31360
        ],
        [
          54528,
          34560
        ]
      ]
    },
    {
      "id": 668,
      "name": "Pets and Walls Make Stronger Kraals",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          61952,
          28544
        ],
        [
          64000,
          32640
        ]
      ]
    },
    {
      "id": 669,
      "name": "Attempted Deicide",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          52224,
          31360
        ],
        [
          54528,
          34560
        ]
      ]
    },
    {
      "id": 670,
      "name": "Doubt",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          52224,
          31360
        ],
        [
          54528,
          34560
        ]
      ]
    },
    {
      "id": 672,
      "name": "Rat-Tastrophe",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          46208,
          25856
        ],
        [
          49408,
          28672
        ]
      ]
    },
    {
      "id": 673,
      "name": "Salvation Through Heresy",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          52224,
          31360
        ],
        [
          54528,
          34560
        ]
      ]
    },
    {
      "id": 674,
      "name": "Enraged and Unashamed",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          52224,
          31360
        ],
        [
          54528,
          34560
        ]
      ]
    },
    {
      "id": 675,
      "name": "Pastkeeper",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          52224,
          31360
        ],
        [
          54528,
          34560
        ]
      ]
    },
    {
      "id": 676,
      "name": "Protest Too Much",
      "min_level": 30,
      "max_level": 35,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 677,
      "name": "Prying the Eye Open",
      "min_level": 30,
      "max_level": 35,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 678,
      "name": "The Hatchery",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          46208,
          25856
        ],
        [
          49408,
          28672
        ]
      ]
    },
    {
      "id": 680,
      "name": "Convincing the Faithful",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          30720,
          39936
        ]
      ],
      "continent_rect": [
        [
          48000,
          32256
        ],
        [
          50432,
          35456
        ]
      ]
    },
    {
      "id": 681,
      "name": "Evacuation",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          52224,
          31360
        ],
        [
          54528,
          34560
        ]
      ]
    },
    {
      "id": 682,
      "name": "Untamed Wilds",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          61952,
          28544
        ],
        [
          64000,
          32640
        ]
      ]
    },
    {
      "id": 683,
      "name": "Champion's Sacrifice",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          30720,
          39936
        ]
      ],
      "continent_rect": [
        [
          48000,
          32256
        ],
        [
          50432,
          35456
        ]
      ]
    },
    {
      "id": 684,
      "name": "Thieving from Thieves",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          46208,
          25856
        ],
        [
          49408,
          28672
        ]
      ]
    },
    {
      "id": 685,
      "name": "Crusader's Return",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 686,
      "name": "Unholy Grounds",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          30720,
          39936
        ]
      ],
      "continent_rect": [
        [
          48000,
          32256
        ],
        [
          50432,
          35456
        ]
      ]
    },
    {
      "id": 687,
      "name": "Chosen of the Sun",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          30720,
          39936
        ]
      ],
      "continent_rect": [
        [
          48000,
          32256
        ],
        [
          50432,
          35456
        ]
      ]
    },
    {
      "id": 691,
      "name": "Set to Blow",
      "min_level": 50,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          46208,
          25856
        ],
        [
          49408,
          28672
        ]
      ]
    },
    {
      "id": 692,
      "name": "Gadd's Last Gizmo",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 693,
      "name": "Library Science",
      "min_level": 40,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 694,
      "name": "Rakt and Ruin",
      "min_level": 30,
      "max_level": 35,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 695,
      "name": "Suspicious Activity",
      "min_level": 60,
      "max_level": 60,
      "default_floor": -3,
      "type": "Instance",
      "floors": [
        -3
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          48768,
          32384
        ],
        [
          49792,
          33408
        ]
      ]
    },
    {
      "id": 696,
      "name": "Reconnaissance",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 697,
      "name": "Critical Blowback",
      "min_level": 60,
      "max_level": 60,
      "default_floor": -3,
      "type": "Instance",
      "floors": [
        -3,
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          48768,
          32384
        ],
        [
          49792,
          33408
        ]
      ]
    },
    {
      "id": 698,
      "name": "The Battle of Claw Island",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -18432
        ],
        [
          18432,
          18432
        ]
      ],
      "continent_rect": [
        [
          46720,
          32256
        ],
        [
          48256,
          33792
        ]
      ]
    },
    {
      "id": 699,
      "name": "Suspicious Activity",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 700,
      "name": "Priory Library",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 701,
      "name": "On Red Alert",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 702,
      "name": "Forearmed Is Forewarned",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 703,
      "name": "The Oratory",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 704,
      "name": "Killing Fields",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 705,
      "name": "The Ghost Rite",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 706,
      "name": "The Good Fight",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          51712,
          34560
        ],
        [
          54016,
          37760
        ]
      ]
    },
    {
      "id": 707,
      "name": "Defense Contract",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          59904,
          25856
        ],
        [
          61952,
          29952
        ]
      ]
    },
    {
      "id": 708,
      "name": "Shards of Orr",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          30720,
          39936
        ]
      ],
      "continent_rect": [
        [
          48000,
          32256
        ],
        [
          50432,
          35456
        ]
      ]
    },
    {
      "id": 709,
      "name": "The Sound of Psi-Lance",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          51712,
          34560
        ],
        [
          54016,
          37760
        ]
      ]
    },
    {
      "id": 710,
      "name": "Early Parole",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 711,
      "name": "Magic Sucks",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 712,
      "name": "A Light in the Darkness",
      "min_level": 60,
      "max_level": 60,
      "default_floor": -16,
      "type": "Instance",
      "floors": [
        1,
        -16,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -33792,
          -24576
        ],
        [
          33792,
          24576
        ]
      ],
      "continent_rect": [
        [
          41088,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 713,
      "name": "The Priory Assailed",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 714,
      "name": "Under Siege",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 715,
      "name": "Retribution",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -18432
        ],
        [
          18432,
          18432
        ]
      ],
      "continent_rect": [
        [
          46720,
          32256
        ],
        [
          48256,
          33792
        ]
      ]
    },
    {
      "id": 716,
      "name": "Retribution",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 719,
      "name": "The Sound of Psi-Lance",
      "min_level": 60,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          51712,
          34560
        ],
        [
          54016,
          37760
        ]
      ]
    },
    {
      "id": 726,
      "name": "Wet Work",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 727,
      "name": "Shell Shock",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 728,
      "name": "Volcanic Extraction",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 729,
      "name": "Munition Acquisition",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 730,
      "name": "To the Core",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 731,
      "name": "The Battle of Fort Trinity",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 732,
      "name": "Tower Down",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -39936
        ],
        [
          30720,
          39936
        ]
      ],
      "continent_rect": [
        [
          48000,
          35456
        ],
        [
          50560,
          38784
        ]
      ]
    },
    {
      "id": 733,
      "name": "Forging the Pact",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          51712,
          34560
        ],
        [
          54016,
          37760
        ]
      ]
    },
    {
      "id": 735,
      "name": "Willing Captives",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 736,
      "name": "Marshaling the Truth",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 737,
      "name": "Breaking the Bone Ship",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 738,
      "name": "Liberating Apatia",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 739,
      "name": "Liberating Apatia",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 743,
      "name": "Fixing the Blame",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          56576,
          24832
        ],
        [
          59904,
          27648
        ]
      ]
    },
    {
      "id": 744,
      "name": "A Sad Duty",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 745,
      "name": "Striking off the Chains",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          51712,
          34560
        ],
        [
          54016,
          37760
        ]
      ]
    },
    {
      "id": 746,
      "name": "Delivering Justice",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 747,
      "name": "Intercepting the Orb",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 750,
      "name": "Close the Eye",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 751,
      "name": "Through the Looking Glass",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 758,
      "name": "The Cathedral of Silence",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42880,
          41600
        ],
        [
          44928,
          45696
        ]
      ]
    },
    {
      "id": 760,
      "name": "Starving the Beast",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          43136,
          39552
        ],
        [
          47232,
          41600
        ]
      ]
    },
    {
      "id": 761,
      "name": "Stealing Light",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          43136,
          39552
        ],
        [
          47232,
          41600
        ]
      ]
    },
    {
      "id": 762,
      "name": "Hunters and Prey",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          43136,
          39552
        ],
        [
          47232,
          41600
        ]
      ]
    },
    {
      "id": 763,
      "name": "Romke's Final Voyage",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42880,
          41600
        ],
        [
          44928,
          45696
        ]
      ]
    },
    {
      "id": 764,
      "name": "Marching Orders",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          43136,
          39552
        ],
        [
          47232,
          41600
        ]
      ]
    },
    {
      "id": 766,
      "name": "Air Drop",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          43136,
          39552
        ],
        [
          47232,
          41600
        ]
      ]
    },
    {
      "id": 767,
      "name": "Estate of Decay",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          43136,
          39552
        ],
        [
          47232,
          41600
        ]
      ]
    },
    {
      "id": 768,
      "name": "What the Eye Beholds",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 769,
      "name": "Conscript the Dead Ships",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          43136,
          39552
        ],
        [
          47232,
          41600
        ]
      ]
    },
    {
      "id": 772,
      "name": "Ossuary of Unquiet Dead",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          43136,
          39552
        ],
        [
          47232,
          41600
        ]
      ]
    },
    {
      "id": 775,
      "name": "Temple of the Forgotten God",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 776,
      "name": "Temple of the Forgotten God",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -8,
      "type": "Instance",
      "floors": [
        1,
        -8
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -6144,
          -6144
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          48000,
          38912
        ],
        [
          48640,
          39552
        ]
      ]
    },
    {
      "id": 777,
      "name": "Temple of the Forgotten God",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 778,
      "name": "Through the Looking Glass",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 779,
      "name": "Starving the Beast",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 780,
      "name": "Against the Corruption",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42880,
          41600
        ],
        [
          44928,
          45696
        ]
      ]
    },
    {
      "id": 781,
      "name": "The Source of Orr",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42880,
          41600
        ],
        [
          44928,
          45696
        ]
      ]
    },
    {
      "id": 782,
      "name": "Armor Guard",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          43136,
          39552
        ],
        [
          47232,
          41600
        ]
      ]
    },
    {
      "id": 783,
      "name": "Blast from the Past",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42880,
          41600
        ],
        [
          44928,
          45696
        ]
      ]
    },
    {
      "id": 784,
      "name": "The Steel Tide",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42880,
          41600
        ],
        [
          44928,
          45696
        ]
      ]
    },
    {
      "id": 785,
      "name": "Further Into Orr",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          43136,
          39552
        ],
        [
          47232,
          41600
        ]
      ]
    },
    {
      "id": 786,
      "name": "Ships of the Line",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42880,
          41600
        ],
        [
          44928,
          45696
        ]
      ]
    },
    {
      "id": 787,
      "name": "Source of Orr",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 788,
      "name": "Victory or Death",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 789,
      "name": "A Grisly Shipment",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          43136,
          39552
        ],
        [
          47232,
          41600
        ]
      ]
    },
    {
      "id": 790,
      "name": "Blast from the Past",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42880,
          41600
        ],
        [
          44928,
          45696
        ]
      ]
    },
    {
      "id": 792,
      "name": "A Pup's Illness",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -55296
        ],
        [
          21504,
          55296
        ]
      ],
      "continent_rect": [
        [
          54528,
          27648
        ],
        [
          56320,
          32256
        ]
      ]
    },
    {
      "id": 793,
      "name": "Hunters and Prey",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 795,
      "name": "Legacy of the Foefire",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 7,
      "type": "Pvp",
      "floors": [
        1,
        7
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -12288
        ],
        [
          12288,
          15360
        ]
      ],
      "continent_rect": [
        [
          2558,
          8190
        ],
        [
          3454,
          9342
        ]
      ]
    },
    {
      "id": 796,
      "name": "The Informant",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          30720
        ]
      ],
      "continent_rect": [
        [
          42624,
          28032
        ],
        [
          46208,
          30464
        ]
      ]
    },
    {
      "id": 797,
      "name": "A Traitor's Testimony",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 799,
      "name": "Follow the Trail",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 806,
      "name": "Awakening",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 807,
      "name": "Eye of the North",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          57344,
          21248
        ],
        [
          58624,
          22528
        ]
      ]
    },
    {
      "id": 820,
      "name": "The Omphalos Chamber",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 821,
      "name": "The Omphalos Chamber",
      "min_level": 10,
      "max_level": 10,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 825,
      "name": "Codebreaker",
      "min_level": 30,
      "max_level": 30,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 827,
      "name": "Caer Aval",
      "min_level": 70,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 828,
      "name": "The Durmand Priory",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 830,
      "name": "Vigil Headquarters",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 833,
      "name": "Ash Tribune Quarters",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 845,
      "name": "Shattered Light",
      "min_level": 20,
      "max_level": 20,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 862,
      "name": "Reaper's Rumble",
      "min_level": 0,
      "max_level": 0,
      "default_floor": -32,
      "type": "Pvp",
      "floors": [
        -32,
        -27
      ],
      "region_id": 25,
      "region_name": "Mad King's Realm",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          2944,
          13440
        ],
        [
          3712,
          14208
        ]
      ]
    },
    {
      "id": 863,
      "name": "Ascent to Madness",
      "min_level": 2,
      "max_level": 80,
      "default_floor": -28,
      "type": "Instance",
      "floors": [
        -28,
        -27
      ],
      "region_id": 25,
      "region_name": "Mad King's Realm",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          2688,
          14208
        ],
        [
          3456,
          14976
        ]
      ]
    },
    {
      "id": 864,
      "name": "Lunatic Inquisition",
      "min_level": 0,
      "max_level": 0,
      "default_floor": -33,
      "type": "Pvp",
      "floors": [
        -33
      ],
      "region_id": 25,
      "region_name": "Mad King's Realm",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          1792,
          13696
        ],
        [
          2560,
          14464
        ]
      ]
    },
    {
      "id": 865,
      "name": "Mad King's Clock Tower",
      "min_level": 0,
      "max_level": 80,
      "default_floor": -30,
      "type": "Pvp",
      "floors": [
        -29,
        -31,
        -30,
        -27
      ],
      "region_id": 25,
      "region_name": "Mad King's Realm",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          1408,
          12544
        ],
        [
          2176,
          13312
        ]
      ]
    },
    {
      "id": 866,
      "name": "Mad King's Labyrinth",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -27,
      "type": "Public",
      "floors": [
        -27
      ],
      "region_id": 25,
      "region_name": "Mad King's Realm",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          1792,
          13696
        ],
        [
          2560,
          14464
        ]
      ]
    },
    {
      "id": 872,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 10,
      "type": "Instance",
      "floors": [
        10
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          11716,
          4346
        ],
        [
          12612,
          5242
        ]
      ]
    },
    {
      "id": 873,
      "name": "Southsun Cove",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -21504
        ],
        [
          33792,
          21504
        ]
      ],
      "continent_rect": [
        [
          44288,
          35328
        ],
        [
          46976,
          37120
        ]
      ]
    },
    {
      "id": 875,
      "name": "Temple of the Silent Storm",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 9,
      "type": "Pvp",
      "floors": [
        1,
        9
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -12288,
          -6144
        ],
        [
          12288,
          9216
        ]
      ],
      "continent_rect": [
        [
          4096,
          9344
        ],
        [
          5120,
          9984
        ]
      ]
    },
    {
      "id": 877,
      "name": "Snowball Mayhem",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 12,
      "type": "Pvp",
      "floors": [
        12
      ],
      "region_id": 27,
      "region_name": "Wintersday Celebration",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          41008,
          26740
        ],
        [
          41776,
          27508
        ]
      ]
    },
    {
      "id": 878,
      "name": "Tixx's Infinirarium",
      "min_level": 2,
      "max_level": 80,
      "default_floor": 13,
      "type": "Instance",
      "floors": [
        13
      ],
      "region_id": 27,
      "region_name": "Wintersday Celebration",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          43008,
          26740
        ],
        [
          43776,
          27508
        ]
      ]
    },
    {
      "id": 880,
      "name": "Toypocalypse",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 14,
      "type": "Pvp",
      "floors": [
        14
      ],
      "region_id": 27,
      "region_name": "Wintersday Celebration",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          43008,
          26740
        ],
        [
          43776,
          27508
        ]
      ]
    },
    {
      "id": 881,
      "name": "Bell Choir Ensemble",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 15,
      "type": "Pvp",
      "floors": [
        15
      ],
      "region_id": 27,
      "region_name": "Wintersday Celebration",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          41008,
          26740
        ],
        [
          41776,
          27508
        ]
      ]
    },
    {
      "id": 882,
      "name": "Winter Wonderland",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 16,
      "type": "Pvp",
      "floors": [
        16
      ],
      "region_id": 27,
      "region_name": "Wintersday Celebration",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          41008,
          26740
        ],
        [
          41776,
          27508
        ]
      ]
    },
    {
      "id": 894,
      "name": "Spirit Watch",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 26,
      "type": "Pvp",
      "floors": [
        1,
        26
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          1920,
          5248
        ],
        [
          2944,
          6272
        ]
      ]
    },
    {
      "id": 895,
      "name": "Super Adventure Box",
      "min_level": 1,
      "max_level": 80,
      "default_floor": 21,
      "type": "Instance",
      "floors": [
        23,
        25,
        24,
        22,
        21
      ],
      "region_id": 29,
      "region_name": "Super Adventure Box",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -61440,
          -21504
        ],
        [
          61440,
          21504
        ]
      ],
      "continent_rect": [
        [
          2176,
          7296
        ],
        [
          3456,
          9856
        ]
      ]
    },
    {
      "id": 896,
      "name": "North Nolan Hatchery",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          27648
        ]
      ],
      "continent_rect": [
        [
          56320,
          27648
        ],
        [
          59904,
          29952
        ]
      ]
    },
    {
      "id": 897,
      "name": "Cragstead",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          55296,
          26368
        ],
        [
          57856,
          28928
        ]
      ]
    },
    {
      "id": 899,
      "name": "Obsidian Sanctum",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 3,
      "type": "JumpPuzzle",
      "floors": [
        3
      ],
      "region_id": 7,
      "region_name": "World vs. World",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          8958,
          12798
        ],
        [
          12030,
          15870
        ]
      ]
    },
    {
      "id": 900,
      "name": "Skyhammer",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 27,
      "type": "Pvp",
      "floors": [
        1,
        27
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -12288,
          -6144
        ],
        [
          12288,
          9216
        ]
      ],
      "continent_rect": [
        [
          7168,
          7422
        ],
        [
          8192,
          8062
        ]
      ]
    },
    {
      "id": 901,
      "name": "Molten Furnace",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 29,
      "type": "Instance",
      "floors": [
        29
      ],
      "region_id": 28,
      "region_name": "Molten Furnace",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -9216
        ],
        [
          12288,
          9216
        ]
      ],
      "continent_rect": [
        [
          11690,
          4414
        ],
        [
          12714,
          5182
        ]
      ]
    },
    {
      "id": 905,
      "name": "Crab Toss",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Pvp",
      "floors": [
        1,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -21504
        ],
        [
          33792,
          21504
        ]
      ],
      "continent_rect": [
        [
          44288,
          35328
        ],
        [
          46976,
          37120
        ]
      ]
    },
    {
      "id": 911,
      "name": "Dragon Ball Arena",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 26,
      "type": "Pvp",
      "floors": [
        26
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          48512,
          30592
        ],
        [
          49536,
          31616
        ]
      ]
    },
    {
      "id": 912,
      "name": "Ceremony and Acrimony—Memorials on the Pyre",
      "min_level": 1,
      "max_level": 80,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 913,
      "name": "Hard Boiled—The Scene of the Crime",
      "min_level": 1,
      "max_level": 80,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 914,
      "name": "The Dead End",
      "min_level": 1,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 915,
      "name": "Aetherblade Retreat",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 27,
      "type": "Instance",
      "floors": [
        27
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -6144,
          -9216
        ],
        [
          6144,
          9216
        ]
      ],
      "continent_rect": [
        [
          47872,
          31616
        ],
        [
          48384,
          32384
        ]
      ]
    },
    {
      "id": 917,
      "name": "No More Secrets—The Scene of the Crime",
      "min_level": 1,
      "max_level": 80,
      "default_floor": 43,
      "type": "Instance",
      "floors": [
        43
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 918,
      "name": "Aspect Arena",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 36,
      "type": "Pvp",
      "floors": [
        36
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          33280,
          16896
        ],
        [
          34304,
          17920
        ]
      ]
    },
    {
      "id": 919,
      "name": "Sanctum Sprint",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 34,
      "type": "Pvp",
      "floors": [
        34
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          55552,
          38654
        ],
        [
          56576,
          39678
        ]
      ]
    },
    {
      "id": 920,
      "name": "Southsun Survival",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 37,
      "type": "Pvp",
      "floors": [
        37
      ],
      "region_id": 9,
      "region_name": "Sea of Sorrows",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -21504
        ],
        [
          33792,
          21504
        ]
      ],
      "continent_rect": [
        [
          44288,
          35328
        ],
        [
          46976,
          37120
        ]
      ]
    },
    {
      "id": 922,
      "name": "Labyrinthine Cliffs",
      "min_level": 1,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -18432
        ],
        [
          18432,
          18432
        ]
      ],
      "continent_rect": [
        [
          54958,
          38648
        ],
        [
          56494,
          40184
        ]
      ]
    },
    {
      "id": 924,
      "name": "Grandmaster of Om",
      "min_level": 1,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 929,
      "name": "The Crown Pavilion",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 38,
      "type": "Public",
      "floors": [
        38
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          43034,
          26880
        ],
        [
          43802,
          27648
        ]
      ]
    },
    {
      "id": 930,
      "name": "Opening Ceremony",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 38,
      "type": "Instance",
      "floors": [
        38
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          43034,
          26880
        ],
        [
          43802,
          27648
        ]
      ]
    },
    {
      "id": 931,
      "name": "Scarlet's Playhouse",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 38,
      "type": "Instance",
      "floors": [
        38
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          43034,
          26880
        ],
        [
          43802,
          27648
        ]
      ]
    },
    {
      "id": 932,
      "name": "Closing Ceremony",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 934,
      "name": "Super Adventure Box",
      "min_level": 1,
      "max_level": 80,
      "default_floor": 28,
      "type": "Instance",
      "floors": [
        29,
        28,
        42
      ],
      "region_id": 29,
      "region_name": "Super Adventure Box",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          4290,
          5120
        ],
        [
          5570,
          7680
        ]
      ]
    },
    {
      "id": 935,
      "name": "Super Adventure Box",
      "min_level": 1,
      "max_level": 80,
      "default_floor": 20,
      "type": "Public",
      "floors": [
        20
      ],
      "region_id": 29,
      "region_name": "Super Adventure Box",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -15360,
          -30720
        ],
        [
          15360,
          30720
        ]
      ],
      "continent_rect": [
        [
          1574,
          5972
        ],
        [
          2854,
          8532
        ]
      ]
    },
    {
      "id": 943,
      "name": "The Tower of Nightmares (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 40,
      "type": "Public",
      "floors": [
        40
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          41344,
          30336
        ],
        [
          45440,
          32384
        ]
      ]
    },
    {
      "id": 945,
      "name": "The Nightmare Ends",
      "min_level": 1,
      "max_level": 80,
      "default_floor": 45,
      "type": "Instance",
      "floors": [
        45
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          41344,
          30336
        ],
        [
          45440,
          32384
        ]
      ]
    },
    {
      "id": 947,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 23,
      "type": "Instance",
      "floors": [
        23
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          10880,
          3328
        ],
        [
          13952,
          6400
        ]
      ]
    },
    {
      "id": 948,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 19,
      "type": "Instance",
      "floors": [
        19
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          11804,
          4414
        ],
        [
          12572,
          5182
        ]
      ]
    },
    {
      "id": 949,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 21,
      "type": "Instance",
      "floors": [
        21
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          11804,
          4414
        ],
        [
          12572,
          5182
        ]
      ]
    },
    {
      "id": 950,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 13,
      "type": "Instance",
      "floors": [
        13
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          10880,
          3328
        ],
        [
          13952,
          6400
        ]
      ]
    },
    {
      "id": 951,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 24,
      "type": "Instance",
      "floors": [
        24
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          10880,
          3328
        ],
        [
          11648,
          4096
        ]
      ]
    },
    {
      "id": 952,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 22,
      "type": "Instance",
      "floors": [
        22
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          11804,
          4414
        ],
        [
          12572,
          5182
        ]
      ]
    },
    {
      "id": 953,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 18,
      "type": "Instance",
      "floors": [
        18
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          10880,
          3328
        ],
        [
          13952,
          6400
        ]
      ]
    },
    {
      "id": 954,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 25,
      "type": "Instance",
      "floors": [
        25
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          10880,
          3328
        ],
        [
          13952,
          6400
        ]
      ]
    },
    {
      "id": 955,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 29,
      "type": "Instance",
      "floors": [
        29
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -12288,
          -9216
        ],
        [
          12288,
          9216
        ]
      ],
      "continent_rect": [
        [
          11690,
          4414
        ],
        [
          12714,
          5182
        ]
      ]
    },
    {
      "id": 956,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 28,
      "type": "Instance",
      "floors": [
        28
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -6144,
          -9216
        ],
        [
          6144,
          9216
        ]
      ],
      "continent_rect": [
        [
          11970,
          4414
        ],
        [
          12482,
          5182
        ]
      ]
    },
    {
      "id": 957,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 30,
      "type": "Instance",
      "floors": [
        30
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          11804,
          4414
        ],
        [
          12572,
          5182
        ]
      ]
    },
    {
      "id": 958,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 14,
      "type": "Instance",
      "floors": [
        14
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          10880,
          3328
        ],
        [
          13952,
          6400
        ]
      ]
    },
    {
      "id": 959,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 29,
      "type": "Instance",
      "floors": [
        29
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -12288,
          -9216
        ],
        [
          12288,
          9216
        ]
      ],
      "continent_rect": [
        [
          11690,
          4414
        ],
        [
          12714,
          5182
        ]
      ]
    },
    {
      "id": 960,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 28,
      "type": "Instance",
      "floors": [
        28
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -6144,
          -9216
        ],
        [
          6144,
          9216
        ]
      ],
      "continent_rect": [
        [
          11970,
          4414
        ],
        [
          12482,
          5182
        ]
      ]
    },
    {
      "id": 964,
      "name": "Scarlet's Secret Lair",
      "min_level": 1,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 968,
      "name": "Edge of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 3,
      "type": "EdgeOfTheMists",
      "floors": [
        1,
        3
      ],
      "region_id": 7,
      "region_name": "World vs. World",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          5994,
          8446
        ],
        [
          9066,
          11518
        ]
      ]
    },
    {
      "id": 984,
      "name": "Courtyard",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 32,
      "type": "Pvp",
      "floors": [
        1,
        32
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          2048,
          7040
        ],
        [
          3072,
          8064
        ]
      ]
    },
    {
      "id": 988,
      "name": "Dry Top",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          36608,
          30976
        ],
        [
          38656,
          33536
        ]
      ]
    },
    {
      "id": 989,
      "name": "Prosperity's Mystery",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          36608,
          30976
        ],
        [
          38656,
          33536
        ]
      ]
    },
    {
      "id": 990,
      "name": "Cornered",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          36608,
          30976
        ],
        [
          38656,
          33536
        ]
      ]
    },
    {
      "id": 991,
      "name": "Disturbance in Brisban Wildlands",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 992,
      "name": "Fallen Hopes",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          36608,
          30976
        ],
        [
          38656,
          33536
        ]
      ]
    },
    {
      "id": 993,
      "name": "Scarlet's Secret Room",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          36608,
          30976
        ],
        [
          38656,
          33536
        ]
      ]
    },
    {
      "id": 994,
      "name": "The Concordia Incident",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          51712,
          34560
        ],
        [
          54016,
          37760
        ]
      ]
    },
    {
      "id": 997,
      "name": "Discovering Scarlet's Breakthrough",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "map_rect": [
        [
          -24576,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          36608,
          30976
        ],
        [
          38656,
          33536
        ]
      ]
    },
    {
      "id": 998,
      "name": "The Machine",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "map_rect": [
        [
          -24576,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          36608,
          30976
        ],
        [
          38656,
          33536
        ]
      ]
    },
    {
      "id": 999,
      "name": "Trouble at Fort Salma",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 1000,
      "name": "The Waypoint Conundrum",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          36608,
          30976
        ],
        [
          38656,
          33536
        ]
      ]
    },
    {
      "id": 1001,
      "name": "Summit Invitations",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 1002,
      "name": "Mission Accomplished",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          53504,
          24576
        ],
        [
          56576,
          27648
        ]
      ]
    },
    {
      "id": 1003,
      "name": "Rallying Call",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        2
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 1004,
      "name": "Plan of Attack",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 1005,
      "name": "Party Politics",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 1006,
      "name": "Foefire Cleansing",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 1007,
      "name": "Recalibrating the Waypoints",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          36608,
          30976
        ],
        [
          38656,
          33536
        ]
      ]
    },
    {
      "id": 1008,
      "name": "The Ghosts of Fort Salma",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 1009,
      "name": "Taimi's Device",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          36608,
          30976
        ],
        [
          38656,
          33536
        ]
      ]
    },
    {
      "id": 1010,
      "name": "The World Summit",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 1011,
      "name": "Battle of Champion's Dusk",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 35,
      "type": "Pvp",
      "floors": [
        1,
        35
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -12288,
          -6144
        ],
        [
          12288,
          9216
        ]
      ],
      "continent_rect": [
        [
          8448,
          7680
        ],
        [
          9472,
          8320
        ]
      ]
    },
    {
      "id": 1015,
      "name": "The Silverwastes",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -18432
        ],
        [
          24576,
          18432
        ]
      ],
      "continent_rect": [
        [
          36608,
          30592
        ],
        [
          38656,
          32128
        ]
      ]
    },
    {
      "id": 1016,
      "name": "Hidden Arcana",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        -14,
        -13
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          49666,
          30720
        ],
        [
          52098,
          32256
        ]
      ]
    },
    {
      "id": 1017,
      "name": "Reunion with the Pact",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -18432
        ],
        [
          24576,
          18432
        ]
      ],
      "continent_rect": [
        [
          36608,
          30592
        ],
        [
          38656,
          32128
        ]
      ]
    },
    {
      "id": 1018,
      "name": "Caithe's Reconnaissance Squad",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -18432
        ],
        [
          24576,
          18432
        ]
      ],
      "continent_rect": [
        [
          36608,
          30592
        ],
        [
          38656,
          32128
        ]
      ]
    },
    {
      "id": 1019,
      "name": "Fort Trinity",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          47232,
          38784
        ],
        [
          50560,
          41600
        ]
      ]
    },
    {
      "id": 1021,
      "name": "Into the Labyrinth",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "map_rect": [
        [
          -24576,
          -18432
        ],
        [
          24576,
          18432
        ]
      ],
      "continent_rect": [
        [
          36608,
          30592
        ],
        [
          38656,
          32128
        ]
      ]
    },
    {
      "id": 1022,
      "name": "Return to Camp Resolve",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -18432
        ],
        [
          24576,
          18432
        ]
      ],
      "continent_rect": [
        [
          36608,
          30592
        ],
        [
          38656,
          32128
        ]
      ]
    },
    {
      "id": 1023,
      "name": "Tracking the Aspect Masters",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "map_rect": [
        [
          -24576,
          -18432
        ],
        [
          24576,
          18432
        ]
      ],
      "continent_rect": [
        [
          36608,
          30592
        ],
        [
          38656,
          32128
        ]
      ]
    },
    {
      "id": 1024,
      "name": "No Refuge",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -18432
        ],
        [
          24576,
          18432
        ]
      ],
      "continent_rect": [
        [
          36608,
          30592
        ],
        [
          38656,
          32128
        ]
      ]
    },
    {
      "id": 1025,
      "name": "The Newly Awakened",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          42496,
          36480
        ],
        [
          43904,
          38528
        ]
      ]
    },
    {
      "id": 1026,
      "name": "Meeting the Asura",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 1027,
      "name": "Pact Assaulted",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -18432
        ],
        [
          24576,
          18432
        ]
      ],
      "continent_rect": [
        [
          36608,
          30592
        ],
        [
          38656,
          32128
        ]
      ]
    },
    {
      "id": 1028,
      "name": "The Mystery Cave",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -18432
        ],
        [
          24576,
          18432
        ]
      ],
      "continent_rect": [
        [
          36608,
          30592
        ],
        [
          38656,
          32128
        ]
      ]
    },
    {
      "id": 1029,
      "name": "Arcana Obscura",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        -13
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          49666,
          30720
        ],
        [
          52098,
          32256
        ]
      ]
    },
    {
      "id": 1032,
      "name": "Prized Possessions",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -33792
        ],
        [
          24576,
          33792
        ]
      ],
      "continent_rect": [
        [
          33280,
          32512
        ],
        [
          35328,
          35328
        ]
      ]
    },
    {
      "id": 1033,
      "name": "Buried Insight",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 0,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -27648
        ],
        [
          39936,
          27648
        ]
      ],
      "continent_rect": [
        [
          35328,
          33792
        ],
        [
          38656,
          36096
        ]
      ]
    },
    {
      "id": 1037,
      "name": "The Jungle Provides",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -18432
        ],
        [
          39936,
          18432
        ]
      ],
      "continent_rect": [
        [
          33408,
          30976
        ],
        [
          36608,
          32512
        ]
      ]
    },
    {
      "id": 1040,
      "name": "Hearts and Minds",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -18,
      "type": "Instance",
      "floors": [
        -20,
        -21,
        -19,
        -18
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          34048,
          37328
        ],
        [
          35200,
          38480
        ]
      ]
    },
    {
      "id": 1041,
      "name": "Dragon's Stand",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -30720
        ],
        [
          36864,
          33792
        ]
      ],
      "continent_rect": [
        [
          34048,
          36096
        ],
        [
          37120,
          38784
        ]
      ]
    },
    {
      "id": 1042,
      "name": "Verdant Brink",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 46,
      "type": "Public",
      "floors": [
        46
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          34208,
          30658
        ],
        [
          37280,
          33730
        ]
      ]
    },
    {
      "id": 1043,
      "name": "Auric Basin",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -33792
        ],
        [
          24576,
          33792
        ]
      ],
      "continent_rect": [
        [
          33280,
          32512
        ],
        [
          35328,
          35328
        ]
      ]
    },
    {
      "id": 1045,
      "name": "Tangled Depths",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -27648
        ],
        [
          39936,
          27648
        ]
      ],
      "continent_rect": [
        [
          35328,
          33792
        ],
        [
          38656,
          36096
        ]
      ]
    },
    {
      "id": 1046,
      "name": "Roots of Terror",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -27648
        ],
        [
          39936,
          27648
        ]
      ],
      "continent_rect": [
        [
          35328,
          33792
        ],
        [
          38656,
          36096
        ]
      ]
    },
    {
      "id": 1048,
      "name": "City of Hope",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -33792
        ],
        [
          24576,
          33792
        ]
      ],
      "continent_rect": [
        [
          33280,
          32512
        ],
        [
          35328,
          35328
        ]
      ]
    },
    {
      "id": 1050,
      "name": "Torn from the Sky",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -18432
        ],
        [
          39936,
          18432
        ]
      ],
      "continent_rect": [
        [
          33408,
          30976
        ],
        [
          36608,
          32512
        ]
      ]
    },
    {
      "id": 1051,
      "name": "Prisoners of the Dragon",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -18432
        ],
        [
          39936,
          18432
        ]
      ],
      "continent_rect": [
        [
          33408,
          30976
        ],
        [
          36608,
          32512
        ]
      ]
    },
    {
      "id": 1052,
      "name": "Verdant Brink",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -18432
        ],
        [
          39936,
          18432
        ]
      ],
      "continent_rect": [
        [
          33408,
          30976
        ],
        [
          36608,
          32512
        ]
      ]
    },
    {
      "id": 1054,
      "name": "Bitter Harvest",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -30720
        ],
        [
          36864,
          33792
        ]
      ],
      "continent_rect": [
        [
          34048,
          36096
        ],
        [
          37120,
          38784
        ]
      ]
    },
    {
      "id": 1057,
      "name": "Strange Observations",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -33792
        ],
        [
          24576,
          33792
        ]
      ],
      "continent_rect": [
        [
          33280,
          32512
        ],
        [
          35328,
          35328
        ]
      ]
    },
    {
      "id": 1058,
      "name": "Prologue: Rally to Maguuma",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Tutorial",
      "floors": [
        1
      ],
      "region_id": 11,
      "region_name": "Maguuma Wastes",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -18432
        ],
        [
          24576,
          18432
        ]
      ],
      "continent_rect": [
        [
          36608,
          30592
        ],
        [
          38656,
          32128
        ]
      ]
    },
    {
      "id": 1062,
      "name": "Spirit Vale",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -36864
        ],
        [
          15360,
          39936
        ]
      ],
      "continent_rect": [
        [
          36224,
          27396
        ],
        [
          37504,
          30596
        ]
      ]
    },
    {
      "id": 1063,
      "name": "Southsun Crab Toss",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -21504
        ],
        [
          33792,
          21504
        ]
      ],
      "continent_rect": [
        [
          44288,
          35328
        ],
        [
          46976,
          37120
        ]
      ]
    },
    {
      "id": 1064,
      "name": "Claiming the Lost Precipice",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 48,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          33536,
          29696
        ],
        [
          34816,
          30976
        ]
      ]
    },
    {
      "id": 1065,
      "name": "Angvar's Trove",
      "min_level": 15,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 1066,
      "name": "Claiming the Gilded Hollow",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 47,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          35328,
          32512
        ],
        [
          36608,
          33792
        ]
      ]
    },
    {
      "id": 1067,
      "name": "Angvar's Trove",
      "min_level": 15,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 1068,
      "name": "Gilded Hollow",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 0,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          35328,
          32512
        ],
        [
          36608,
          33792
        ]
      ]
    },
    {
      "id": 1069,
      "name": "Lost Precipice",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          33536,
          29696
        ],
        [
          34816,
          30976
        ]
      ]
    },
    {
      "id": 1070,
      "name": "Claiming the Lost Precipice",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 48,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          33536,
          29696
        ],
        [
          34816,
          30976
        ]
      ]
    },
    {
      "id": 1071,
      "name": "Lost Precipice",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          33536,
          29696
        ],
        [
          34816,
          30976
        ]
      ]
    },
    {
      "id": 1072,
      "name": "Southsun Crab Toss",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -21504
        ],
        [
          33792,
          21504
        ]
      ],
      "continent_rect": [
        [
          44288,
          35328
        ],
        [
          46976,
          37120
        ]
      ]
    },
    {
      "id": 1073,
      "name": "Guild Initiative Office",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 1074,
      "name": "Blightwater Shatterstrike",
      "min_level": 40,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          61952,
          28544
        ],
        [
          64000,
          32640
        ]
      ]
    },
    {
      "id": 1075,
      "name": "Proxemics Lab",
      "min_level": 15,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 1076,
      "name": "Lost Precipice",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          33536,
          29696
        ],
        [
          34816,
          30976
        ]
      ]
    },
    {
      "id": 1078,
      "name": "Claiming the Gilded Hollow",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 47,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          35328,
          32512
        ],
        [
          36608,
          33792
        ]
      ]
    },
    {
      "id": 1079,
      "name": "Deep Trouble",
      "min_level": 60,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 1080,
      "name": "Branded for Termination",
      "min_level": 30,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          61440,
          32640
        ],
        [
          64512,
          35712
        ]
      ]
    },
    {
      "id": 1081,
      "name": "Langmar Estate",
      "min_level": 1,
      "max_level": 15,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 1082,
      "name": "Langmar Estate",
      "min_level": 1,
      "max_level": 15,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 1083,
      "name": "Deep Trouble",
      "min_level": 60,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 1084,
      "name": "Southsun Crab Toss",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -21504
        ],
        [
          33792,
          21504
        ]
      ],
      "continent_rect": [
        [
          44288,
          35328
        ],
        [
          46976,
          37120
        ]
      ]
    },
    {
      "id": 1086,
      "name": "Save Our Supplies",
      "min_level": 50,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          59904,
          25856
        ],
        [
          61952,
          29952
        ]
      ]
    },
    {
      "id": 1087,
      "name": "Proxemics Lab",
      "min_level": 15,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 1088,
      "name": "Claiming the Gilded Hollow",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 47,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          35328,
          32512
        ],
        [
          36608,
          33792
        ]
      ]
    },
    {
      "id": 1089,
      "name": "Angvar's Trove",
      "min_level": 15,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 1090,
      "name": "Langmar Estate",
      "min_level": 1,
      "max_level": 15,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 1091,
      "name": "Save Our Supplies",
      "min_level": 50,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          59904,
          25856
        ],
        [
          61952,
          29952
        ]
      ]
    },
    {
      "id": 1092,
      "name": "Scratch Sentry Defense",
      "min_level": 50,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          51712,
          34560
        ],
        [
          54016,
          37760
        ]
      ]
    },
    {
      "id": 1093,
      "name": "Angvar's Trove",
      "min_level": 15,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 1094,
      "name": "Save Our Supplies",
      "min_level": 50,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          59904,
          25856
        ],
        [
          61952,
          29952
        ]
      ]
    },
    {
      "id": 1095,
      "name": "Dragon's Stand (Heart of Thorns)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -30720
        ],
        [
          36864,
          33792
        ]
      ],
      "continent_rect": [
        [
          34048,
          36096
        ],
        [
          37120,
          38784
        ]
      ]
    },
    {
      "id": 1097,
      "name": "Proxemics Lab",
      "min_level": 15,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 1098,
      "name": "Claiming the Gilded Hollow",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 47,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          35328,
          32512
        ],
        [
          36608,
          33792
        ]
      ]
    },
    {
      "id": 1099,
      "name": " Desert Borderlands",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 3,
      "type": "RedHome",
      "floors": [
        1,
        3
      ],
      "region_id": 7,
      "region_name": "World vs. World",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          9214,
          8958
        ],
        [
          12286,
          12030
        ]
      ]
    },
    {
      "id": 1100,
      "name": "Scratch Sentry Defense",
      "min_level": 50,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          51712,
          34560
        ],
        [
          54016,
          37760
        ]
      ]
    },
    {
      "id": 1101,
      "name": "Gilded Hollow",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 0,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          35328,
          32512
        ],
        [
          36608,
          33792
        ]
      ]
    },
    {
      "id": 1104,
      "name": "Lost Precipice",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          33536,
          29696
        ],
        [
          34816,
          30976
        ]
      ]
    },
    {
      "id": 1105,
      "name": "Langmar Estate",
      "min_level": 1,
      "max_level": 15,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 1106,
      "name": "Deep Trouble",
      "min_level": 60,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 1107,
      "name": "Gilded Hollow",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 0,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          35328,
          32512
        ],
        [
          36608,
          33792
        ]
      ]
    },
    {
      "id": 1108,
      "name": "Gilded Hollow",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 0,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          35328,
          32512
        ],
        [
          36608,
          33792
        ]
      ]
    },
    {
      "id": 1109,
      "name": "Angvar's Trove",
      "min_level": 15,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 1110,
      "name": "Scrap Rifle Field Test",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 0,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -27648
        ],
        [
          39936,
          27648
        ]
      ],
      "continent_rect": [
        [
          35328,
          33792
        ],
        [
          38656,
          36096
        ]
      ]
    },
    {
      "id": 1111,
      "name": "Scratch Sentry Defense",
      "min_level": 50,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          51712,
          34560
        ],
        [
          54016,
          37760
        ]
      ]
    },
    {
      "id": 1112,
      "name": "Branded for Termination",
      "min_level": 30,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          61440,
          32640
        ],
        [
          64512,
          35712
        ]
      ]
    },
    {
      "id": 1113,
      "name": "Scratch Sentry Defense",
      "min_level": 50,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          51712,
          34560
        ],
        [
          54016,
          37760
        ]
      ]
    },
    {
      "id": 1115,
      "name": "Haywire Punch-o-Matic Battle",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 0,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -27648
        ],
        [
          39936,
          27648
        ]
      ],
      "continent_rect": [
        [
          35328,
          33792
        ],
        [
          38656,
          36096
        ]
      ]
    },
    {
      "id": 1116,
      "name": "Deep Trouble",
      "min_level": 60,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 1117,
      "name": "Claiming the Lost Precipice",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 48,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          33536,
          29696
        ],
        [
          34816,
          30976
        ]
      ]
    },
    {
      "id": 1118,
      "name": "Save Our Supplies",
      "min_level": 50,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          59904,
          25856
        ],
        [
          61952,
          29952
        ]
      ]
    },
    {
      "id": 1121,
      "name": "Gilded Hollow",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 0,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          35328,
          32512
        ],
        [
          36608,
          33792
        ]
      ]
    },
    {
      "id": 1122,
      "name": "Claiming the Gilded Hollow",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 47,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          35328,
          32512
        ],
        [
          36608,
          33792
        ]
      ]
    },
    {
      "id": 1123,
      "name": "Blightwater Shatterstrike",
      "min_level": 40,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          61952,
          28544
        ],
        [
          64000,
          32640
        ]
      ]
    },
    {
      "id": 1124,
      "name": "Lost Precipice",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          33536,
          29696
        ],
        [
          34816,
          30976
        ]
      ]
    },
    {
      "id": 1126,
      "name": "Southsun Crab Toss",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -21504
        ],
        [
          33792,
          21504
        ]
      ],
      "continent_rect": [
        [
          44288,
          35328
        ],
        [
          46976,
          37120
        ]
      ]
    },
    {
      "id": 1128,
      "name": "Scratch Sentry Defense",
      "min_level": 50,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          51712,
          34560
        ],
        [
          54016,
          37760
        ]
      ]
    },
    {
      "id": 1129,
      "name": "Langmar Estate",
      "min_level": 1,
      "max_level": 15,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          57856,
          29952
        ],
        [
          61952,
          32000
        ]
      ]
    },
    {
      "id": 1130,
      "name": "Deep Trouble",
      "min_level": 60,
      "max_level": 70,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 1131,
      "name": "Blightwater Shatterstrike",
      "min_level": 40,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          61952,
          28544
        ],
        [
          64000,
          32640
        ]
      ]
    },
    {
      "id": 1132,
      "name": "Claiming the Lost Precipice",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 48,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          33536,
          29696
        ],
        [
          34816,
          30976
        ]
      ]
    },
    {
      "id": 1133,
      "name": "Branded for Termination",
      "min_level": 30,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          61440,
          32640
        ],
        [
          64512,
          35712
        ]
      ]
    },
    {
      "id": 1134,
      "name": "Blightwater Shatterstrike",
      "min_level": 40,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          61952,
          28544
        ],
        [
          64000,
          32640
        ]
      ]
    },
    {
      "id": 1135,
      "name": "Branded for Termination",
      "min_level": 30,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          61440,
          32640
        ],
        [
          64512,
          35712
        ]
      ]
    },
    {
      "id": 1136,
      "name": "Proxemics Lab",
      "min_level": 15,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 1137,
      "name": "Proxemics Lab",
      "min_level": 15,
      "max_level": 25,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 1138,
      "name": "Save Our Supplies",
      "min_level": 50,
      "max_level": 60,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          59904,
          25856
        ],
        [
          61952,
          29952
        ]
      ]
    },
    {
      "id": 1139,
      "name": "Southsun Crab Toss",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -21504
        ],
        [
          33792,
          21504
        ]
      ],
      "continent_rect": [
        [
          44288,
          35328
        ],
        [
          46976,
          37120
        ]
      ]
    },
    {
      "id": 1140,
      "name": "Claiming the Lost Precipice",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 48,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          33536,
          29696
        ],
        [
          34816,
          30976
        ]
      ]
    },
    {
      "id": 1142,
      "name": "Blightwater Shatterstrike",
      "min_level": 40,
      "max_level": 50,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          61952,
          28544
        ],
        [
          64000,
          32640
        ]
      ]
    },
    {
      "id": 1146,
      "name": "Branded for Termination",
      "min_level": 30,
      "max_level": 40,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          61440,
          32640
        ],
        [
          64512,
          35712
        ]
      ]
    },
    {
      "id": 1147,
      "name": "Spirit Vale",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -36864
        ],
        [
          15360,
          39936
        ]
      ],
      "continent_rect": [
        [
          36224,
          27396
        ],
        [
          37504,
          30596
        ]
      ]
    },
    {
      "id": 1149,
      "name": "Salvation Pass",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -27648
        ],
        [
          12288,
          27648
        ]
      ],
      "continent_rect": [
        [
          35456,
          28290
        ],
        [
          36480,
          30594
        ]
      ]
    },
    {
      "id": 1153,
      "name": "Tiger Den",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 1154,
      "name": "Special Forces Training Area",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -22,
      "type": "Instance",
      "floors": [
        -22
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30846
        ],
        [
          50432,
          32382
        ]
      ]
    },
    {
      "id": 1155,
      "name": "Lion's Arch Aerodrome",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          47964,
          30806
        ],
        [
          50396,
          32342
        ]
      ]
    },
    {
      "id": 1156,
      "name": "Stronghold of the Faithful",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -27648
        ],
        [
          12288,
          27648
        ]
      ],
      "continent_rect": [
        [
          34688,
          28544
        ],
        [
          35712,
          30848
        ]
      ]
    },
    {
      "id": 1158,
      "name": "Noble's Folly",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        48
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -18432
        ],
        [
          39936,
          18432
        ]
      ],
      "continent_rect": [
        [
          33408,
          30976
        ],
        [
          36608,
          32512
        ]
      ]
    },
    {
      "id": 1159,
      "name": "Research in Rata Novus",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -27648
        ],
        [
          39936,
          27648
        ]
      ],
      "continent_rect": [
        [
          35328,
          33792
        ],
        [
          38656,
          36096
        ]
      ]
    },
    {
      "id": 1161,
      "name": "Eir's Homestead",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 1163,
      "name": "Revenge of the Capricorn",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 8,
      "type": "Pvp",
      "floors": [
        1,
        8
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          7950,
          6545
        ],
        [
          8718,
          7313
        ]
      ]
    },
    {
      "id": 1164,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 20,
      "type": "Instance",
      "floors": [
        20
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -18432,
          -12288
        ],
        [
          18432,
          12288
        ]
      ],
      "continent_rect": [
        [
          11804,
          4414
        ],
        [
          13340,
          5438
        ]
      ]
    },
    {
      "id": 1165,
      "name": "Bloodstone Fen",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 2,
      "type": "Public",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -6144
        ],
        [
          18432,
          9216
        ]
      ],
      "continent_rect": [
        [
          34816,
          30338
        ],
        [
          36352,
          30978
        ]
      ]
    },
    {
      "id": 1166,
      "name": "Confessor's Stronghold",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        2
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -6144
        ],
        [
          18432,
          9216
        ]
      ],
      "continent_rect": [
        [
          34816,
          30338
        ],
        [
          36352,
          30978
        ]
      ]
    },
    {
      "id": 1167,
      "name": "A Shadow's Deeds",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 0,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -6144
        ],
        [
          18432,
          9216
        ]
      ],
      "continent_rect": [
        [
          34816,
          30338
        ],
        [
          36352,
          30978
        ]
      ]
    },
    {
      "id": 1169,
      "name": "Rata Novus",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        -7,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -27648
        ],
        [
          39936,
          27648
        ]
      ],
      "continent_rect": [
        [
          35328,
          33792
        ],
        [
          38656,
          36096
        ]
      ]
    },
    {
      "id": 1170,
      "name": "Taimi's Game",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -27648
        ],
        [
          39936,
          27648
        ]
      ],
      "continent_rect": [
        [
          35328,
          33792
        ],
        [
          38656,
          36096
        ]
      ]
    },
    {
      "id": 1171,
      "name": "Eternal Coliseum",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 37,
      "type": "Pvp",
      "floors": [
        1,
        37
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -12288,
          -9216
        ],
        [
          12288,
          9216
        ]
      ],
      "continent_rect": [
        [
          10268,
          6812
        ],
        [
          11292,
          7580
        ]
      ]
    },
    {
      "id": 1172,
      "name": "Dragon Vigil",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -33792
        ],
        [
          24576,
          33792
        ]
      ],
      "continent_rect": [
        [
          33280,
          32512
        ],
        [
          35328,
          35328
        ]
      ]
    },
    {
      "id": 1173,
      "name": "Taimi's Game",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -24,
      "type": "Instance",
      "floors": [
        -24
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          37504,
          34432
        ],
        [
          38272,
          35200
        ]
      ]
    },
    {
      "id": 1175,
      "name": "Ember Bay",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -46080
        ],
        [
          46080,
          46080
        ]
      ],
      "continent_rect": [
        [
          37374,
          43518
        ],
        [
          41214,
          47358
        ]
      ]
    },
    {
      "id": 1176,
      "name": "Taimi's Game",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -27648
        ],
        [
          39936,
          27648
        ]
      ],
      "continent_rect": [
        [
          35328,
          33792
        ],
        [
          38656,
          36096
        ]
      ]
    },
    {
      "id": 1177,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 16,
      "type": "Instance",
      "floors": [
        16
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -6144,
          -6144
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          11804,
          4414
        ],
        [
          12444,
          5054
        ]
      ]
    },
    {
      "id": 1178,
      "name": "Bitterfrost Frontier",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -18432
        ],
        [
          36864,
          18432
        ]
      ],
      "continent_rect": [
        [
          53504,
          23040
        ],
        [
          56576,
          24576
        ]
      ]
    },
    {
      "id": 1180,
      "name": "The Bitter Cold",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -18432
        ],
        [
          36864,
          18432
        ]
      ],
      "continent_rect": [
        [
          53504,
          23040
        ],
        [
          56576,
          24576
        ]
      ]
    },
    {
      "id": 1181,
      "name": "Frozen Out",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -18432
        ],
        [
          36864,
          18432
        ]
      ],
      "continent_rect": [
        [
          53504,
          23040
        ],
        [
          56576,
          24576
        ]
      ]
    },
    {
      "id": 1182,
      "name": "Precocious Aurene",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 0,
      "type": "Instance",
      "floors": [
        47,
        0
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -33792
        ],
        [
          24576,
          33792
        ]
      ],
      "continent_rect": [
        [
          33280,
          32512
        ],
        [
          35328,
          35328
        ]
      ]
    },
    {
      "id": 1185,
      "name": "Lake Doric",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -30720
        ],
        [
          15360,
          30720
        ]
      ],
      "continent_rect": [
        [
          44928,
          25472
        ],
        [
          46208,
          28032
        ]
      ]
    },
    {
      "id": 1188,
      "name": "Bastion of the Penitent",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -9216
        ],
        [
          27648,
          12288
        ]
      ],
      "continent_rect": [
        [
          44542,
          20864
        ],
        [
          46846,
          21760
        ]
      ]
    },
    {
      "id": 1189,
      "name": "Regrouping with the Queen",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 1190,
      "name": "A Meeting of Ministers",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 1191,
      "name": "Confessor's End",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 4,
      "type": "Instance",
      "floors": [
        5,
        -4,
        4
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          45184,
          27776
        ],
        [
          46208,
          28800
        ]
      ]
    },
    {
      "id": 1192,
      "name": "The Second Vision",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        2
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -18432
        ],
        [
          39936,
          18432
        ]
      ],
      "continent_rect": [
        [
          33408,
          30976
        ],
        [
          36608,
          32512
        ]
      ]
    },
    {
      "id": 1193,
      "name": "The First Vision",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          42112,
          30464
        ],
        [
          46208,
          32512
        ]
      ]
    },
    {
      "id": 1194,
      "name": "The Sword Regrown",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -49152
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42880,
          41600
        ],
        [
          44928,
          45696
        ]
      ]
    },
    {
      "id": 1195,
      "name": "Draconis Mons",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 20,
      "region_name": "Ring of Fire",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -46080
        ],
        [
          46080,
          46080
        ]
      ],
      "continent_rect": [
        [
          34718,
          39284
        ],
        [
          38558,
          43124
        ]
      ]
    },
    {
      "id": 1196,
      "name": "Heart of the Volcano",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -28,
      "type": "Instance",
      "floors": [
        -28,
        -26,
        -27
      ],
      "region_id": 20,
      "region_name": "Ring of Fire",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -46080
        ],
        [
          46080,
          46080
        ]
      ],
      "continent_rect": [
        [
          34718,
          39284
        ],
        [
          38558,
          43124
        ]
      ]
    },
    {
      "id": 1198,
      "name": "Taimi's Pet Project",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        47,
        2,
        0,
        48,
        3
      ],
      "region_id": 10,
      "region_name": "Heart of Maguuma",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -27648
        ],
        [
          39936,
          27648
        ]
      ],
      "continent_rect": [
        [
          35328,
          33792
        ],
        [
          38656,
          36096
        ]
      ]
    },
    {
      "id": 1200,
      "name": "Hall of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 39,
      "type": "Pvp",
      "floors": [
        1,
        39
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -6144,
          -6144
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          5172,
          4370
        ],
        [
          5812,
          5010
        ]
      ]
    },
    {
      "id": 1201,
      "name": "Asura Arena",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 40,
      "type": "Pvp",
      "floors": [
        1,
        40
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -6144,
          -6144
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          4448,
          4908
        ],
        [
          4768,
          5228
        ]
      ]
    },
    {
      "id": 1202,
      "name": "White Mantle Hideout",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -34,
      "type": "Instance",
      "floors": [
        -34
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -27648
        ],
        [
          12288,
          27648
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          39680,
          33152
        ]
      ]
    },
    {
      "id": 1203,
      "name": "Siren's Landing",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -15360
        ],
        [
          39936,
          15360
        ]
      ],
      "continent_rect": [
        [
          47002,
          41600
        ],
        [
          50330,
          42880
        ]
      ]
    },
    {
      "id": 1204,
      "name": "Palace Temple",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 1205,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 15,
      "type": "Instance",
      "floors": [
        15
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -24576,
          -24576
        ],
        [
          24576,
          24576
        ]
      ],
      "continent_rect": [
        [
          11204,
          4414
        ],
        [
          13252,
          6462
        ]
      ]
    },
    {
      "id": 1206,
      "name": "Mistlock Sanctuary",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -31,
      "type": "Public",
      "floors": [
        -31
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          46368,
          33520
        ],
        [
          48416,
          35568
        ]
      ]
    },
    {
      "id": 1207,
      "name": "The Last Chance",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 3,
      "region_name": "Ruins of Orr",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -15360
        ],
        [
          39936,
          15360
        ]
      ],
      "continent_rect": [
        [
          47002,
          41600
        ],
        [
          50330,
          42880
        ]
      ]
    },
    {
      "id": 1208,
      "name": "Shining Blade Headquarters",
      "min_level": 0,
      "max_level": 80,
      "default_floor": -33,
      "type": "Instance",
      "floors": [
        -33
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          44008,
          26440
        ],
        [
          44776,
          27208
        ]
      ]
    },
    {
      "id": 1209,
      "name": "The Sacrifice",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -61440,
          -30720
        ],
        [
          61440,
          30720
        ]
      ],
      "continent_rect": [
        [
          57256,
          39744
        ],
        [
          62376,
          42304
        ]
      ]
    },
    {
      "id": 1210,
      "name": "Crystal Oasis",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -61440,
          -30720
        ],
        [
          61440,
          30720
        ]
      ],
      "continent_rect": [
        [
          57256,
          42304
        ],
        [
          62376,
          44864
        ]
      ]
    },
    {
      "id": 1211,
      "name": "Desert Highlands",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -61440,
          -30720
        ],
        [
          61440,
          30720
        ]
      ],
      "continent_rect": [
        [
          57256,
          39744
        ],
        [
          62376,
          42304
        ]
      ]
    },
    {
      "id": 1212,
      "name": "Office of the Chief Councilor",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -61440,
          -30720
        ],
        [
          61440,
          30720
        ]
      ],
      "continent_rect": [
        [
          57256,
          42304
        ],
        [
          62376,
          44864
        ]
      ]
    },
    {
      "id": 1214,
      "name": "Windswept Haven",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          64016,
          51072
        ],
        [
          65296,
          52352
        ]
      ]
    },
    {
      "id": 1215,
      "name": "Windswept Haven",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          64016,
          51072
        ],
        [
          65296,
          52352
        ]
      ]
    },
    {
      "id": 1217,
      "name": "Sparking the Flame",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -61440,
          -30720
        ],
        [
          61440,
          30720
        ]
      ],
      "continent_rect": [
        [
          57256,
          42304
        ],
        [
          62376,
          44864
        ]
      ]
    },
    {
      "id": 1219,
      "name": "Enemy of My Enemy: The Beastmarshal",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "map_rect": [
        [
          -58368,
          -36864
        ],
        [
          58368,
          39936
        ]
      ],
      "continent_rect": [
        [
          63616,
          52352
        ],
        [
          68480,
          55552
        ]
      ]
    },
    {
      "id": 1220,
      "name": "Sparking the Flame (Prologue)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 1221,
      "name": "The Way Forward",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -30,
      "type": "Instance",
      "floors": [
        -30
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -33792,
          -27648
        ],
        [
          36864,
          30720
        ]
      ],
      "continent_rect": [
        [
          57968,
          44484
        ],
        [
          60912,
          46916
        ]
      ]
    },
    {
      "id": 1222,
      "name": "Claiming Windswept Haven",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 49,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          64016,
          51072
        ],
        [
          65296,
          52352
        ]
      ]
    },
    {
      "id": 1223,
      "name": "Small Victory (Epilogue)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -61440,
          -30720
        ],
        [
          61440,
          30720
        ]
      ],
      "continent_rect": [
        [
          57256,
          42304
        ],
        [
          62376,
          44864
        ]
      ]
    },
    {
      "id": 1224,
      "name": "Windswept Haven",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          64016,
          51072
        ],
        [
          65296,
          52352
        ]
      ]
    },
    {
      "id": 1226,
      "name": "The Desolation",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -61440
        ],
        [
          43008,
          61440
        ]
      ],
      "continent_rect": [
        [
          58240,
          48192
        ],
        [
          61824,
          53312
        ]
      ]
    },
    {
      "id": 1227,
      "name": "Hallowed Ground: Tomb of Primeval Kings",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -61440,
          -30720
        ],
        [
          61440,
          30720
        ]
      ],
      "continent_rect": [
        [
          57256,
          39744
        ],
        [
          62376,
          42304
        ]
      ]
    },
    {
      "id": 1228,
      "name": "Elon Riverlands",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -39936
        ],
        [
          43008,
          43008
        ]
      ],
      "continent_rect": [
        [
          58240,
          44736
        ],
        [
          61824,
          48192
        ]
      ]
    },
    {
      "id": 1230,
      "name": "Facing the Truth: The Sanctum",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -35,
      "type": "Instance",
      "floors": [
        -36,
        -35
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          60768,
          37384
        ],
        [
          64608,
          39944
        ]
      ]
    },
    {
      "id": 1231,
      "name": "Claiming Windswept Haven",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 49,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          64016,
          51072
        ],
        [
          65296,
          52352
        ]
      ]
    },
    {
      "id": 1232,
      "name": "Windswept Haven",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          64016,
          51072
        ],
        [
          65296,
          52352
        ]
      ]
    },
    {
      "id": 1234,
      "name": "To Kill a God",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -58368,
          -36864
        ],
        [
          58368,
          39936
        ]
      ],
      "continent_rect": [
        [
          63616,
          52352
        ],
        [
          68480,
          55552
        ]
      ]
    },
    {
      "id": 1236,
      "name": "Claiming Windswept Haven",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 49,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          64016,
          51072
        ],
        [
          65296,
          52352
        ]
      ]
    },
    {
      "id": 1240,
      "name": "Blazing a Trail",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -61440,
          -30720
        ],
        [
          61440,
          30720
        ]
      ],
      "continent_rect": [
        [
          57256,
          42304
        ],
        [
          62376,
          44864
        ]
      ]
    },
    {
      "id": 1241,
      "name": "Night of Fires",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -61440,
          -30720
        ],
        [
          61440,
          30720
        ]
      ],
      "continent_rect": [
        [
          57256,
          42304
        ],
        [
          62376,
          44864
        ]
      ]
    },
    {
      "id": 1242,
      "name": "Zalambur's Office",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -61440,
          -30720
        ],
        [
          61440,
          30720
        ]
      ],
      "continent_rect": [
        [
          57256,
          42304
        ],
        [
          62376,
          44864
        ]
      ]
    },
    {
      "id": 1243,
      "name": "Windswept Haven",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          64016,
          51072
        ],
        [
          65296,
          52352
        ]
      ]
    },
    {
      "id": 1244,
      "name": "Claiming Windswept Haven",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 49,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          64016,
          51072
        ],
        [
          65296,
          52352
        ]
      ]
    },
    {
      "id": 1245,
      "name": "The Departing",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        41,
        2,
        0,
        3,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -33792,
          -27648
        ],
        [
          36864,
          30720
        ]
      ],
      "continent_rect": [
        [
          56963,
          46274
        ],
        [
          59907,
          48706
        ]
      ]
    },
    {
      "id": 1246,
      "name": "Captain Kiel's Office",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          30720,
          18432
        ]
      ],
      "continent_rect": [
        [
          48000,
          30720
        ],
        [
          50432,
          32256
        ]
      ]
    },
    {
      "id": 1247,
      "name": "Enemy of My Enemy",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "map_rect": [
        [
          -43008,
          -61440
        ],
        [
          43008,
          61440
        ]
      ],
      "continent_rect": [
        [
          58240,
          48192
        ],
        [
          61824,
          53312
        ]
      ]
    },
    {
      "id": 1248,
      "name": "Domain of Vabbi",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -58368,
          -36864
        ],
        [
          58368,
          39936
        ]
      ],
      "continent_rect": [
        [
          63616,
          52352
        ],
        [
          68480,
          55552
        ]
      ]
    },
    {
      "id": 1250,
      "name": "Windswept Haven",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          64016,
          51072
        ],
        [
          65296,
          52352
        ]
      ]
    },
    {
      "id": 1252,
      "name": "Crystalline Memories",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        -29,
        1,
        2,
        0,
        3,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -61440,
          -30720
        ],
        [
          61440,
          30720
        ]
      ],
      "continent_rect": [
        [
          57256,
          39744
        ],
        [
          62376,
          42304
        ]
      ]
    },
    {
      "id": 1253,
      "name": "Beast of War",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -58368,
          -36864
        ],
        [
          58368,
          39936
        ]
      ],
      "continent_rect": [
        [
          63616,
          52352
        ],
        [
          68480,
          55552
        ]
      ]
    },
    {
      "id": 1255,
      "name": "Enemy of My Enemy: The Troopmarshal",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "map_rect": [
        [
          -58368,
          -36864
        ],
        [
          58368,
          39936
        ]
      ],
      "continent_rect": [
        [
          63616,
          52352
        ],
        [
          68480,
          55552
        ]
      ]
    },
    {
      "id": 1256,
      "name": "The Dark Library",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -36,
      "type": "Instance",
      "floors": [
        -36
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          60768,
          37384
        ],
        [
          64608,
          39944
        ]
      ]
    },
    {
      "id": 1257,
      "name": "Spearmarshal's Lament",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -58368,
          -36864
        ],
        [
          58368,
          39936
        ]
      ],
      "continent_rect": [
        [
          63616,
          52352
        ],
        [
          68480,
          55552
        ]
      ]
    },
    {
      "id": 1260,
      "name": "Eye of the Brandstorm",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -21504
        ],
        [
          30720,
          21504
        ]
      ],
      "continent_rect": [
        [
          57768,
          43069
        ],
        [
          60328,
          44861
        ]
      ]
    },
    {
      "id": 1263,
      "name": "Domain of Istan",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -46080
        ],
        [
          46080,
          46080
        ]
      ],
      "continent_rect": [
        [
          55318,
          59916
        ],
        [
          59158,
          63756
        ]
      ]
    },
    {
      "id": 1264,
      "name": "Hall of Chains",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -32,
      "type": "Instance",
      "floors": [
        -32
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -12288
        ],
        [
          24576,
          12288
        ]
      ],
      "continent_rect": [
        [
          51840,
          31868
        ],
        [
          53760,
          32892
        ]
      ]
    },
    {
      "id": 1265,
      "name": "The Hero of Istan",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -46080
        ],
        [
          46080,
          46080
        ]
      ],
      "continent_rect": [
        [
          55318,
          59916
        ],
        [
          59158,
          63756
        ]
      ]
    },
    {
      "id": 1266,
      "name": "Cave of the Sunspear Champion",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -46080
        ],
        [
          46080,
          46080
        ]
      ],
      "continent_rect": [
        [
          55318,
          59916
        ],
        [
          59158,
          63756
        ]
      ]
    },
    {
      "id": 1267,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 12,
      "type": "Instance",
      "floors": [
        12
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          11716,
          4346
        ],
        [
          13764,
          6394
        ]
      ]
    },
    {
      "id": 1268,
      "name": "Fahranur, the First City",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          52304,
          61488
        ],
        [
          53584,
          62768
        ]
      ]
    },
    {
      "id": 1270,
      "name": "Toypocalypse",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 17,
      "type": "Instance",
      "floors": [
        17
      ],
      "region_id": 27,
      "region_name": "Wintersday Celebration",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          43008,
          26740
        ],
        [
          43776,
          27508
        ]
      ]
    },
    {
      "id": 1271,
      "name": "Sandswept Isles",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -52224
        ],
        [
          39936,
          52224
        ]
      ],
      "continent_rect": [
        [
          51994,
          55402
        ],
        [
          55194,
          59754
        ]
      ]
    },
    {
      "id": 1274,
      "name": "The Charge",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 50,
      "type": "Instance",
      "floors": [
        50
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -52224
        ],
        [
          39936,
          52224
        ]
      ],
      "continent_rect": [
        [
          51994,
          55402
        ],
        [
          55194,
          59754
        ]
      ]
    },
    {
      "id": 1275,
      "name": "Courtyard",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 32,
      "type": "Pvp",
      "floors": [
        32
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          2048,
          7040
        ],
        [
          3072,
          8064
        ]
      ]
    },
    {
      "id": 1276,
      "name": "The Test Subject",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -52224
        ],
        [
          39936,
          52224
        ]
      ],
      "continent_rect": [
        [
          51994,
          55402
        ],
        [
          55194,
          59754
        ]
      ]
    },
    {
      "id": 1277,
      "name": "The Charge",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 50,
      "type": "Instance",
      "floors": [
        50
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -52224
        ],
        [
          39936,
          52224
        ]
      ],
      "continent_rect": [
        [
          51994,
          55402
        ],
        [
          55194,
          59754
        ]
      ]
    },
    {
      "id": 1278,
      "name": "???",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        48
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          53504,
          24576
        ],
        [
          56576,
          27648
        ]
      ]
    },
    {
      "id": 1279,
      "name": "ERROR: SIGNAL LOST",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -37,
      "type": "Instance",
      "floors": [
        -37
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -24576
        ],
        [
          24576,
          24576
        ]
      ],
      "continent_rect": [
        [
          43972,
          20798
        ],
        [
          46020,
          22846
        ]
      ]
    },
    {
      "id": 1281,
      "name": "A Kindness Repaid",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -52224
        ],
        [
          39936,
          52224
        ]
      ],
      "continent_rect": [
        [
          51994,
          55402
        ],
        [
          55194,
          59754
        ]
      ]
    },
    {
      "id": 1282,
      "name": "Tracking the Scientist",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -21504
        ],
        [
          15360,
          24576
        ]
      ],
      "continent_rect": [
        [
          59686,
          40139
        ],
        [
          60966,
          42059
        ]
      ]
    },
    {
      "id": 1283,
      "name": "???",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -27648
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          50560,
          37760
        ],
        [
          54400,
          40192
        ]
      ]
    },
    {
      "id": 1285,
      "name": "???",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 1288,
      "name": "Domain of Kourna",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -55296
        ],
        [
          49152,
          58368
        ]
      ],
      "continent_rect": [
        [
          63624,
          59572
        ],
        [
          67720,
          64308
        ]
      ]
    },
    {
      "id": 1289,
      "name": "Seized",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          57256,
          42304
        ],
        [
          59816,
          44864
        ]
      ]
    },
    {
      "id": 1290,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 31,
      "type": "Instance",
      "floors": [
        31
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          21504,
          21504
        ]
      ],
      "continent_rect": [
        [
          11804,
          4414
        ],
        [
          13596,
          6206
        ]
      ]
    },
    {
      "id": 1291,
      "name": "Forearmed Is Forewarned",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 53,
      "type": "Instance",
      "floors": [
        53
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -55296
        ],
        [
          49152,
          58368
        ]
      ],
      "continent_rect": [
        [
          63624,
          59572
        ],
        [
          67720,
          64308
        ]
      ]
    },
    {
      "id": 1292,
      "name": "Be My Guest",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -55296
        ],
        [
          49152,
          58368
        ]
      ],
      "continent_rect": [
        [
          63624,
          59572
        ],
        [
          67720,
          64308
        ]
      ]
    },
    {
      "id": 1294,
      "name": "Sun's Refuge",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -36864
        ],
        [
          49152,
          39936
        ]
      ],
      "continent_rect": [
        [
          63316,
          56376
        ],
        [
          67412,
          59576
        ]
      ]
    },
    {
      "id": 1295,
      "name": "Legacy",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -36864
        ],
        [
          49152,
          39936
        ]
      ],
      "continent_rect": [
        [
          63316,
          56376
        ],
        [
          67412,
          59576
        ]
      ]
    },
    {
      "id": 1296,
      "name": "Storm Tracking",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 51,
      "type": "Instance",
      "floors": [
        51
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -36864,
          -52224
        ],
        [
          39936,
          55296
        ]
      ],
      "continent_rect": [
        [
          60768,
          37384
        ],
        [
          63968,
          41864
        ]
      ]
    },
    {
      "id": 1297,
      "name": "A Shattered Nation",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -36864
        ],
        [
          49152,
          39936
        ]
      ],
      "continent_rect": [
        [
          63316,
          56376
        ],
        [
          67412,
          59576
        ]
      ]
    },
    {
      "id": 1299,
      "name": "Storm Tracking",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -36864
        ],
        [
          49152,
          39936
        ]
      ],
      "continent_rect": [
        [
          63316,
          56376
        ],
        [
          67412,
          59576
        ]
      ]
    },
    {
      "id": 1300,
      "name": "From the Ashes—The Deadeye",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -36864
        ],
        [
          49152,
          39936
        ]
      ],
      "continent_rect": [
        [
          63316,
          56376
        ],
        [
          67412,
          59576
        ]
      ]
    },
    {
      "id": 1301,
      "name": "Jahai Bluffs",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -36864
        ],
        [
          49152,
          39936
        ]
      ],
      "continent_rect": [
        [
          63316,
          56376
        ],
        [
          67412,
          59576
        ]
      ]
    },
    {
      "id": 1302,
      "name": "Storm Tracking",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -36864
        ],
        [
          49152,
          39936
        ]
      ],
      "continent_rect": [
        [
          63316,
          56376
        ],
        [
          67412,
          59576
        ]
      ]
    },
    {
      "id": 1303,
      "name": "Mythwright Gambit",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -38,
      "type": "Instance",
      "floors": [
        -38
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          30720
        ],
        [
          48128,
          32640
        ]
      ]
    },
    {
      "id": 1304,
      "name": "Mad King's Raceway",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -34,
      "type": "Public",
      "floors": [
        -34
      ],
      "region_id": 25,
      "region_name": "Mad King's Realm",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          2944,
          13440
        ],
        [
          3712,
          14208
        ]
      ]
    },
    {
      "id": 1305,
      "name": "Djinn's Dominion",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 44,
      "type": "Pvp",
      "floors": [
        1,
        44
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -24576,
          -12288
        ],
        [
          24576,
          12288
        ]
      ],
      "continent_rect": [
        [
          11812,
          5488
        ],
        [
          13860,
          6512
        ]
      ]
    },
    {
      "id": 1306,
      "name": "Secret Lair of the Snowmen (Squad)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -39,
      "type": "Instance",
      "floors": [
        -39
      ],
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          52268,
          24384
        ],
        [
          53548,
          25664
        ]
      ]
    },
    {
      "id": 1308,
      "name": "Scion & Champion",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -56,
      "type": "Instance",
      "floors": [
        -55,
        -56
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -24576
        ],
        [
          15360,
          27648
        ]
      ],
      "continent_rect": [
        [
          52752,
          31958
        ],
        [
          54032,
          34134
        ]
      ]
    },
    {
      "id": 1309,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 11,
      "type": "Instance",
      "floors": [
        11
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          24576
        ]
      ],
      "continent_rect": [
        [
          11804,
          4414
        ],
        [
          13724,
          6334
        ]
      ]
    },
    {
      "id": 1310,
      "name": "Thunderhead Peaks",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -43008
        ],
        [
          39936,
          46080
        ]
      ],
      "continent_rect": [
        [
          55820,
          34936
        ],
        [
          59148,
          38648
        ]
      ]
    },
    {
      "id": 1313,
      "name": "The Crystal Dragon",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -53,
      "type": "Instance",
      "floors": [
        -53
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          18432
        ]
      ],
      "continent_rect": [
        [
          55418,
          35200
        ],
        [
          57722,
          36736
        ]
      ]
    },
    {
      "id": 1314,
      "name": "The Crystal Blooms",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -53,
      "type": "Instance",
      "floors": [
        -53
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          18432
        ]
      ],
      "continent_rect": [
        [
          55418,
          35200
        ],
        [
          57722,
          36736
        ]
      ]
    },
    {
      "id": 1315,
      "name": "Armistice Bastion",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 3,
      "type": "Unknown",
      "floors": [
        3
      ],
      "region_id": 7,
      "region_name": "World vs. World",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          21504,
          21504
        ]
      ],
      "continent_rect": [
        [
          13798,
          8646
        ],
        [
          15590,
          10438
        ]
      ]
    },
    {
      "id": 1316,
      "name": "Mists Rift",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -35,
      "type": "Public",
      "floors": [
        -35
      ],
      "region_id": 25,
      "region_name": "Mad King's Realm",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -6144,
          -6144
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          2944,
          13440
        ],
        [
          3584,
          14080
        ]
      ]
    },
    {
      "id": 1317,
      "name": "Dragonfall",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          43968,
          48384
        ],
        [
          47424,
          51200
        ]
      ]
    },
    {
      "id": 1318,
      "name": "Dragonfall",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        49
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          43968,
          48384
        ],
        [
          47424,
          51200
        ]
      ]
    },
    {
      "id": 1319,
      "name": "Descent",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -57,
      "type": "Instance",
      "floors": [
        -57
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          24576
        ]
      ],
      "continent_rect": [
        [
          45068,
          51084
        ],
        [
          46988,
          53004
        ]
      ]
    },
    {
      "id": 1320,
      "name": "The End",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -53,
      "type": "Instance",
      "floors": [
        -53
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          18432
        ]
      ],
      "continent_rect": [
        [
          55418,
          35200
        ],
        [
          57722,
          36736
        ]
      ]
    },
    {
      "id": 1321,
      "name": "Dragonflight",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -52,
      "type": "Instance",
      "floors": [
        -52
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -24576
        ],
        [
          24576,
          24576
        ]
      ],
      "continent_rect": [
        [
          27000,
          21000
        ],
        [
          29048,
          23048
        ]
      ]
    },
    {
      "id": 1322,
      "name": "Epilogue",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 54,
      "type": "Instance",
      "floors": [
        54
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -9216,
          -9216
        ],
        [
          9216,
          9216
        ]
      ],
      "continent_rect": [
        [
          45638,
          47135
        ],
        [
          46406,
          47903
        ]
      ]
    },
    {
      "id": 1323,
      "name": "The Key of Ahdashim",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        49,
        2,
        0
      ],
      "region_id": 12,
      "region_name": "Crystal Desert",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          24576
        ]
      ],
      "continent_rect": [
        [
          66298,
          50434
        ],
        [
          68218,
          52354
        ]
      ]
    },
    {
      "id": 1326,
      "name": "Dragon Bash Arena",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 1327,
      "name": "Dragon Arena Survival",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 1328,
      "name": "Auric Span",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 41,
      "type": "Pvp",
      "floors": [
        1,
        41
      ],
      "region_id": 6,
      "region_name": "Player vs. Player",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -18432,
          -18432
        ],
        [
          18432,
          18432
        ]
      ],
      "continent_rect": [
        [
          9104,
          4834
        ],
        [
          10640,
          6370
        ]
      ]
    },
    {
      "id": 1329,
      "name": "Coming Home",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -30720
        ],
        [
          39936,
          30720
        ]
      ],
      "continent_rect": [
        [
          59392,
          17504
        ],
        [
          62592,
          20064
        ]
      ]
    },
    {
      "id": 1330,
      "name": "Grothmar Valley",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -30720
        ],
        [
          39936,
          30720
        ]
      ],
      "continent_rect": [
        [
          59392,
          17504
        ],
        [
          62592,
          20064
        ]
      ]
    },
    {
      "id": 1331,
      "name": "Strike Mission: Shiverpeaks Pass (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -30720
        ],
        [
          39936,
          30720
        ]
      ],
      "continent_rect": [
        [
          59392,
          17504
        ],
        [
          62592,
          20064
        ]
      ]
    },
    {
      "id": 1332,
      "name": "Strike Mission: Shiverpeaks Pass (Squad)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -30720
        ],
        [
          39936,
          30720
        ]
      ],
      "continent_rect": [
        [
          59392,
          17504
        ],
        [
          62592,
          20064
        ]
      ]
    },
    {
      "id": 1334,
      "name": "Deeper and Deeper",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -30720
        ],
        [
          39936,
          30720
        ]
      ],
      "continent_rect": [
        [
          59392,
          17504
        ],
        [
          62592,
          20064
        ]
      ]
    },
    {
      "id": 1336,
      "name": "A Race to Arms",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -30720
        ],
        [
          39936,
          30720
        ]
      ],
      "continent_rect": [
        [
          59392,
          17504
        ],
        [
          62592,
          20064
        ]
      ]
    },
    {
      "id": 1338,
      "name": "Bad Blood",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -30720
        ],
        [
          39936,
          30720
        ]
      ],
      "continent_rect": [
        [
          59392,
          17504
        ],
        [
          62592,
          20064
        ]
      ]
    },
    {
      "id": 1339,
      "name": "Weekly Strike Mission: Boneskinner (Squad)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 61,
      "type": "Instance",
      "floors": [
        61
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          56712,
          17494
        ],
        [
          57729,
          18511
        ]
      ]
    },
    {
      "id": 1340,
      "name": "Weekly Strike Mission: Voice of the Fallen and Claw of the Fallen (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 62,
      "type": "Public",
      "floors": [
        62
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          56712,
          17494
        ],
        [
          57729,
          18511
        ]
      ]
    },
    {
      "id": 1341,
      "name": "Weekly Strike Mission: Fraenir of Jormag (Squad)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 60,
      "type": "Instance",
      "floors": [
        60
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          56712,
          17494
        ],
        [
          57729,
          18511
        ]
      ]
    },
    {
      "id": 1342,
      "name": "The Invitation",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -52224,
          -24576
        ],
        [
          55296,
          27648
        ]
      ],
      "continent_rect": [
        [
          54911,
          16972
        ],
        [
          59391,
          19148
        ]
      ]
    },
    {
      "id": 1343,
      "name": "Bjora Marches",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -52224,
          -24576
        ],
        [
          55296,
          27648
        ]
      ],
      "continent_rect": [
        [
          54911,
          16972
        ],
        [
          59391,
          19148
        ]
      ]
    },
    {
      "id": 1344,
      "name": "Weekly Strike Mission: Fraenir of Jormag (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 60,
      "type": "Public",
      "floors": [
        60
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          56712,
          17494
        ],
        [
          57729,
          18511
        ]
      ]
    },
    {
      "id": 1345,
      "name": "What's Left Behind",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -52224,
          -24576
        ],
        [
          55296,
          27648
        ]
      ],
      "continent_rect": [
        [
          54911,
          16972
        ],
        [
          59391,
          19148
        ]
      ]
    },
    {
      "id": 1346,
      "name": "Weekly Strike Mission: Voice of the Fallen and Claw of the Fallen (Squad)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 62,
      "type": "Instance",
      "floors": [
        62
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          56712,
          17494
        ],
        [
          57729,
          18511
        ]
      ]
    },
    {
      "id": 1349,
      "name": "Silence",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -52224,
          -24576
        ],
        [
          55296,
          27648
        ]
      ],
      "continent_rect": [
        [
          54911,
          16972
        ],
        [
          59391,
          19148
        ]
      ]
    },
    {
      "id": 1351,
      "name": "Weekly Strike Mission: Boneskinner (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 61,
      "type": "Public",
      "floors": [
        61
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          56712,
          17494
        ],
        [
          57729,
          18511
        ]
      ]
    },
    {
      "id": 1352,
      "name": "Secret Lair of the Snowmen (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -39,
      "type": "Public",
      "floors": [
        -39
      ],
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          52268,
          24384
        ],
        [
          53548,
          25664
        ]
      ]
    },
    {
      "id": 1353,
      "name": "Celestial Challenge",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 2,
      "type": "Public",
      "floors": [
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 1355,
      "name": "Voice in the Deep",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -40,
      "type": "Instance",
      "floors": [
        -40
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -9216,
          -6144
        ],
        [
          9216,
          6144
        ]
      ],
      "continent_rect": [
        [
          55528,
          18980
        ],
        [
          56296,
          19492
        ]
      ]
    },
    {
      "id": 1356,
      "name": "Chasing Ghosts",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -52224,
          -24576
        ],
        [
          55296,
          27648
        ]
      ],
      "continent_rect": [
        [
          54911,
          16972
        ],
        [
          59391,
          19148
        ]
      ]
    },
    {
      "id": 1357,
      "name": "Strike Mission: Whisper of Jormag (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -41,
      "type": "Public",
      "floors": [
        -41
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -6144,
          -6144
        ],
        [
          6144,
          6144
        ]
      ],
      "continent_rect": [
        [
          55528,
          18980
        ],
        [
          56040,
          19492
        ]
      ]
    },
    {
      "id": 1358,
      "name": "Eye of the North",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          57344,
          21248
        ],
        [
          58624,
          22528
        ]
      ]
    },
    {
      "id": 1359,
      "name": "Strike Mission: Whisper of Jormag (Squad)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -41,
      "type": "Instance",
      "floors": [
        -41
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -6144,
          -6144
        ],
        [
          6144,
          6144
        ]
      ],
      "continent_rect": [
        [
          55528,
          18980
        ],
        [
          56040,
          19492
        ]
      ]
    },
    {
      "id": 1361,
      "name": "The Nightmare Incarnate",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 45,
      "type": "Instance",
      "floors": [
        45
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          41344,
          30336
        ],
        [
          45440,
          32384
        ]
      ]
    },
    {
      "id": 1362,
      "name": "Forging Steel (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 58,
      "type": "Public",
      "floors": [
        58
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          11432,
          3640
        ],
        [
          12968,
          5688
        ]
      ]
    },
    {
      "id": 1363,
      "name": "New Friends, New Enemies—North Nolan Hatchery",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -43008,
          -27648
        ],
        [
          43008,
          27648
        ]
      ],
      "continent_rect": [
        [
          56320,
          27648
        ],
        [
          59904,
          29952
        ]
      ]
    },
    {
      "id": 1364,
      "name": "The Battle for Cragstead",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          55296,
          26368
        ],
        [
          57856,
          28928
        ]
      ]
    },
    {
      "id": 1366,
      "name": "Darkrime Delves",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -42,
      "type": "Instance",
      "floors": [
        -42
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -9216
        ],
        [
          24576,
          12288
        ]
      ],
      "continent_rect": [
        [
          51268,
          17184
        ],
        [
          53188,
          18080
        ]
      ]
    },
    {
      "id": 1368,
      "name": "Forging Steel (Squad)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 58,
      "type": "Instance",
      "floors": [
        58
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          11432,
          3640
        ],
        [
          12968,
          5688
        ]
      ]
    },
    {
      "id": 1369,
      "name": "Canach's Lair",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -21504
        ],
        [
          33792,
          21504
        ]
      ],
      "continent_rect": [
        [
          44288,
          35328
        ],
        [
          46976,
          37120
        ]
      ]
    },
    {
      "id": 1370,
      "name": "Eye of the North",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          57344,
          21248
        ],
        [
          58624,
          22528
        ]
      ]
    },
    {
      "id": 1371,
      "name": "Drizzlewood Coast",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -52224
        ],
        [
          27648,
          55296
        ]
      ],
      "continent_rect": [
        [
          50128,
          17809
        ],
        [
          52304,
          22289
        ]
      ]
    },
    {
      "id": 1372,
      "name": "Turnabout",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -52224
        ],
        [
          27648,
          55296
        ]
      ],
      "continent_rect": [
        [
          50128,
          17809
        ],
        [
          52304,
          22289
        ]
      ]
    },
    {
      "id": 1373,
      "name": "Pointed Parley",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -52224
        ],
        [
          27648,
          55296
        ]
      ],
      "continent_rect": [
        [
          50128,
          17809
        ],
        [
          52304,
          22289
        ]
      ]
    },
    {
      "id": 1374,
      "name": "Strike Mission: Cold War (Squad)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -43,
      "type": "Instance",
      "floors": [
        -43
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -12288
        ],
        [
          15360,
          12288
        ]
      ],
      "continent_rect": [
        [
          50128,
          17809
        ],
        [
          51408,
          18833
        ]
      ]
    },
    {
      "id": 1375,
      "name": "Snapping Steel",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -52224
        ],
        [
          27648,
          55296
        ]
      ],
      "continent_rect": [
        [
          50128,
          17809
        ],
        [
          52304,
          22289
        ]
      ]
    },
    {
      "id": 1376,
      "name": "Strike Mission: Cold War (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -43,
      "type": "Public",
      "floors": [
        -43
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -12288
        ],
        [
          15360,
          12288
        ]
      ],
      "continent_rect": [
        [
          50128,
          17809
        ],
        [
          51408,
          18833
        ]
      ]
    },
    {
      "id": 1378,
      "name": "Behind Enemy Lines",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -52224
        ],
        [
          27648,
          55296
        ]
      ],
      "continent_rect": [
        [
          50128,
          17809
        ],
        [
          52304,
          22289
        ]
      ]
    },
    {
      "id": 1379,
      "name": "One Charr, One Dragon, One Champion",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 0,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -52224
        ],
        [
          27648,
          55296
        ]
      ],
      "continent_rect": [
        [
          50128,
          17809
        ],
        [
          52304,
          22289
        ]
      ]
    },
    {
      "id": 1380,
      "name": "Epilogue",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          57344,
          21248
        ],
        [
          58624,
          22528
        ]
      ]
    },
    {
      "id": 1382,
      "name": "Arena of the Wolverine",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -52224
        ],
        [
          27648,
          55296
        ]
      ],
      "continent_rect": [
        [
          50128,
          17809
        ],
        [
          52304,
          22289
        ]
      ]
    },
    {
      "id": 1383,
      "name": "A Simple Negotiation",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -52224
        ],
        [
          27648,
          55296
        ]
      ],
      "continent_rect": [
        [
          50128,
          17809
        ],
        [
          52304,
          22289
        ]
      ]
    },
    {
      "id": 1384,
      "name": "Fractals of the Mists",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 51,
      "type": "Instance",
      "floors": [
        51
      ],
      "region_id": 26,
      "region_name": "Fractals of the Mists",
      "continent_id": 2,
      "continent_name": "Mists",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          11204,
          4414
        ],
        [
          12228,
          5438
        ]
      ]
    },
    {
      "id": 1385,
      "name": "Caledon Forest (Private)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 56,
      "type": "Instance",
      "floors": [
        56
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 1386,
      "name": "Thunderhead Peaks (Private)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 63,
      "type": "Instance",
      "floors": [
        63
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -43008
        ],
        [
          39936,
          46080
        ]
      ],
      "continent_rect": [
        [
          55820,
          34936
        ],
        [
          59148,
          38648
        ]
      ]
    },
    {
      "id": 1387,
      "name": "Bloodtide Coast (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 64,
      "type": "Public",
      "floors": [
        64
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          30720,
          39936
        ]
      ],
      "continent_rect": [
        [
          48000,
          32256
        ],
        [
          50432,
          35456
        ]
      ]
    },
    {
      "id": 1388,
      "name": "Snowden Drifts (Private)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 58,
      "type": "Instance",
      "floors": [
        58
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 1389,
      "name": "Snowden Drifts (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 58,
      "type": "Public",
      "floors": [
        58
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          50432,
          27648
        ],
        [
          54528,
          29696
        ]
      ]
    },
    {
      "id": 1390,
      "name": "Fireheart Rise (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 67,
      "type": "Public",
      "floors": [
        67
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          56576,
          24832
        ],
        [
          59904,
          27648
        ]
      ]
    },
    {
      "id": 1391,
      "name": "Brisban Wildlands (Private)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 57,
      "type": "Instance",
      "floors": [
        57
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 1392,
      "name": "Primordus Rising",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 1393,
      "name": "Lake Doric (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 65,
      "type": "Public",
      "floors": [
        65
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -30720
        ],
        [
          15360,
          30720
        ]
      ],
      "continent_rect": [
        [
          44928,
          25472
        ],
        [
          46208,
          28032
        ]
      ]
    },
    {
      "id": 1394,
      "name": "Bloodtide Coast (Private)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 64,
      "type": "Instance",
      "floors": [
        64
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -36864
        ],
        [
          30720,
          39936
        ]
      ],
      "continent_rect": [
        [
          48000,
          32256
        ],
        [
          50432,
          35456
        ]
      ]
    },
    {
      "id": 1395,
      "name": "Thunderhead Peaks (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 63,
      "type": "Public",
      "floors": [
        63
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -43008
        ],
        [
          39936,
          46080
        ]
      ],
      "continent_rect": [
        [
          55820,
          34936
        ],
        [
          59148,
          38648
        ]
      ]
    },
    {
      "id": 1396,
      "name": "Gendarran Fields (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 66,
      "type": "Public",
      "floors": [
        66
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 1397,
      "name": "Metrica Province (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 55,
      "type": "Public",
      "floors": [
        55
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 1398,
      "name": "Fields of Ruin (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 68,
      "type": "Public",
      "floors": [
        68
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          61440,
          32640
        ],
        [
          64512,
          35712
        ]
      ]
    },
    {
      "id": 1399,
      "name": "Brisban Wildlands (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 57,
      "type": "Public",
      "floors": [
        57
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -30720
        ],
        [
          43008,
          33792
        ]
      ],
      "continent_rect": [
        [
          38656,
          30848
        ],
        [
          42112,
          33536
        ]
      ]
    },
    {
      "id": 1400,
      "name": "Fields of Ruin (Private)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 68,
      "type": "Instance",
      "floors": [
        68
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -36864,
          -36864
        ],
        [
          36864,
          36864
        ]
      ],
      "continent_rect": [
        [
          61440,
          32640
        ],
        [
          64512,
          35712
        ]
      ]
    },
    {
      "id": 1401,
      "name": "Metrica Province (Private)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 55,
      "type": "Instance",
      "floors": [
        55
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -39936
        ],
        [
          27648,
          39936
        ]
      ],
      "continent_rect": [
        [
          39936,
          33536
        ],
        [
          42112,
          36864
        ]
      ]
    },
    {
      "id": 1402,
      "name": "Lake Doric (Private)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 65,
      "type": "Instance",
      "floors": [
        65
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -30720
        ],
        [
          15360,
          30720
        ]
      ],
      "continent_rect": [
        [
          44928,
          25472
        ],
        [
          46208,
          28032
        ]
      ]
    },
    {
      "id": 1403,
      "name": "Caledon Forest (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 56,
      "type": "Public",
      "floors": [
        57,
        56
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -46080
        ],
        [
          24576,
          49152
        ]
      ],
      "continent_rect": [
        [
          42112,
          32512
        ],
        [
          44032,
          36480
        ]
      ]
    },
    {
      "id": 1404,
      "name": "Fireheart Rise (Private)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 67,
      "type": "Instance",
      "floors": [
        67
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -39936,
          -33792
        ],
        [
          39936,
          33792
        ]
      ],
      "continent_rect": [
        [
          56576,
          24832
        ],
        [
          59904,
          27648
        ]
      ]
    },
    {
      "id": 1405,
      "name": "Gendarran Fields (Private)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 66,
      "type": "Instance",
      "floors": [
        66
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          52224,
          24576
        ]
      ],
      "continent_rect": [
        [
          46208,
          28672
        ],
        [
          50432,
          30720
        ]
      ]
    },
    {
      "id": 1407,
      "name": "Council Level",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 5,
      "region_name": "Tarnished Coast",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -30720,
          -30720
        ],
        [
          30720,
          30720
        ]
      ],
      "continent_rect": [
        [
          37376,
          36094
        ],
        [
          39936,
          38654
        ]
      ]
    },
    {
      "id": 1408,
      "name": "Wildfire",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -28,
      "type": "Instance",
      "floors": [
        -28,
        -26,
        -27
      ],
      "region_id": 20,
      "region_name": "Ring of Fire",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -46080
        ],
        [
          46080,
          46080
        ]
      ],
      "continent_rect": [
        [
          34718,
          39284
        ],
        [
          38558,
          43124
        ]
      ]
    },
    {
      "id": 1409,
      "name": "Dragonstorm (Private Squad)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 59,
      "type": "Instance",
      "floors": [
        59
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -18432
        ],
        [
          18432,
          18432
        ]
      ],
      "continent_rect": [
        [
          51968,
          26112
        ],
        [
          53504,
          27648
        ]
      ]
    },
    {
      "id": 1410,
      "name": "Champion's End",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 59,
      "type": "Instance",
      "floors": [
        59
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -18432
        ],
        [
          18432,
          18432
        ]
      ],
      "continent_rect": [
        [
          51968,
          26112
        ],
        [
          53504,
          27648
        ]
      ]
    },
    {
      "id": 1411,
      "name": "Dragonstorm (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 59,
      "type": "Public",
      "floors": [
        59
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -18432
        ],
        [
          18432,
          18432
        ]
      ],
      "continent_rect": [
        [
          51968,
          26112
        ],
        [
          53504,
          27648
        ]
      ]
    },
    {
      "id": 1412,
      "name": "Dragonstorm",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 59,
      "type": "Instance",
      "floors": [
        59
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -18432
        ],
        [
          18432,
          18432
        ]
      ],
      "continent_rect": [
        [
          51968,
          26112
        ],
        [
          53504,
          27648
        ]
      ]
    },
    {
      "id": 1413,
      "name": "The Twisted Marionette (Public)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 60,
      "type": "Public",
      "floors": [
        60,
        58
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 1414,
      "name": "The Twisted Marionette (Private Squad)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 60,
      "type": "Instance",
      "floors": [
        60,
        58
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -58368
        ],
        [
          21504,
          58368
        ]
      ],
      "continent_rect": [
        [
          50432,
          29696
        ],
        [
          52224,
          34560
        ]
      ]
    },
    {
      "id": 1415,
      "name": "The Future in Jade: Power Plant",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          25000,
          98100
        ],
        [
          28840,
          100660
        ]
      ]
    },
    {
      "id": 1416,
      "name": "Deepest Secrets: Yong Reactor",
      "min_level": 80,
      "max_level": 80,
      "default_floor": -44,
      "type": "Instance",
      "floors": [
        -44
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -12288,
          -12288
        ],
        [
          12288,
          12288
        ]
      ],
      "continent_rect": [
        [
          23976,
          98110
        ],
        [
          25000,
          99134
        ]
      ]
    },
    {
      "id": 1419,
      "name": "Isle of Reflection",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          21319,
          103145
        ],
        [
          23239,
          105705
        ]
      ]
    },
    {
      "id": 1420,
      "name": "Fallout: Nika's Blade",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          25000,
          98100
        ],
        [
          28840,
          100660
        ]
      ]
    },
    {
      "id": 1421,
      "name": "???",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          33792
        ]
      ],
      "continent_rect": [
        [
          21159,
          100457
        ],
        [
          24999,
          103145
        ]
      ]
    },
    {
      "id": 1422,
      "name": "Dragon's End",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        69,
        1,
        3,
        2,
        0
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -43008
        ],
        [
          27648,
          46080
        ]
      ],
      "continent_rect": [
        [
          33126,
          101838
        ],
        [
          35302,
          105550
        ]
      ]
    },
    {
      "id": 1426,
      "name": "Isle of Reflection",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          21319,
          103145
        ],
        [
          23239,
          105705
        ]
      ]
    },
    {
      "id": 1427,
      "name": "Weight of the World: Lady Joon's Estate",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          33792
        ]
      ],
      "continent_rect": [
        [
          21159,
          100457
        ],
        [
          24999,
          103145
        ]
      ]
    },
    {
      "id": 1428,
      "name": "Arborstone",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        69,
        1,
        3,
        2,
        0
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          29185,
          100890
        ],
        [
          33025,
          103450
        ]
      ]
    },
    {
      "id": 1429,
      "name": "The Cycle, Reborn: Arborstone",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          29185,
          100890
        ],
        [
          33025,
          103450
        ]
      ]
    },
    {
      "id": 1430,
      "name": "Claiming the Isle of Reflection",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 69,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          21319,
          103145
        ],
        [
          23239,
          105705
        ]
      ]
    },
    {
      "id": 1432,
      "name": "Strike Mission: Aetherblade Hideout",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 72,
      "type": "Instance",
      "floors": [
        72
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -3072,
          -3072
        ],
        [
          6144,
          6144
        ]
      ],
      "continent_rect": [
        [
          23600,
          102380
        ],
        [
          23984,
          102764
        ]
      ]
    },
    {
      "id": 1433,
      "name": "Old Friends",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          27648
        ]
      ],
      "continent_rect": [
        [
          50432,
          31484
        ],
        [
          51968,
          33660
        ]
      ]
    },
    {
      "id": 1434,
      "name": "Empty",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          29185,
          100890
        ],
        [
          33025,
          103450
        ]
      ]
    },
    {
      "id": 1435,
      "name": "Isle of Reflection",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          21319,
          103145
        ],
        [
          23239,
          105705
        ]
      ]
    },
    {
      "id": 1436,
      "name": "Extraction Point: Command Quarters",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          29185,
          100890
        ],
        [
          33025,
          103450
        ]
      ]
    },
    {
      "id": 1437,
      "name": "Strike Mission: Harvest Temple",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 71,
      "type": "Instance",
      "floors": [
        71
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -43008
        ],
        [
          27648,
          46080
        ]
      ],
      "continent_rect": [
        [
          33126,
          101838
        ],
        [
          35302,
          105550
        ]
      ]
    },
    {
      "id": 1438,
      "name": "New Kaineng City",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        69,
        1,
        3,
        2,
        0
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          25000,
          98100
        ],
        [
          28840,
          100660
        ]
      ]
    },
    {
      "id": 1439,
      "name": "The Only One",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -43008
        ],
        [
          27648,
          46080
        ]
      ],
      "continent_rect": [
        [
          33126,
          101838
        ],
        [
          35302,
          105550
        ]
      ]
    },
    {
      "id": 1440,
      "name": "Laying to Rest",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -24576,
          -43008
        ],
        [
          27648,
          46080
        ]
      ],
      "continent_rect": [
        [
          33126,
          101838
        ],
        [
          35302,
          105550
        ]
      ]
    },
    {
      "id": 1442,
      "name": "Seitung Province",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        69,
        1,
        3,
        2,
        0
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          33792
        ]
      ],
      "continent_rect": [
        [
          21159,
          100457
        ],
        [
          24999,
          103145
        ]
      ]
    },
    {
      "id": 1444,
      "name": "Isle of Reflection",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          21319,
          103145
        ],
        [
          23239,
          105705
        ]
      ]
    },
    {
      "id": 1445,
      "name": "The Future in Jade: Nahpui Lab",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          25000,
          98100
        ],
        [
          28840,
          100660
        ]
      ]
    },
    {
      "id": 1446,
      "name": "Aetherblade Armada",
      "min_level": 0,
      "max_level": 80,
      "default_floor": -53,
      "type": "Instance",
      "floors": [
        -53
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          100,
          100
        ],
        [
          2148,
          2148
        ]
      ]
    },
    {
      "id": 1448,
      "name": "The Cycle, Reborn: The Dead End Bar",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 1449,
      "name": "Aurene's Sanctuary",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          33792
        ]
      ],
      "continent_rect": [
        [
          21159,
          100457
        ],
        [
          24999,
          103145
        ]
      ]
    },
    {
      "id": 1450,
      "name": "Strike Mission: Xunlai Jade Junkyard",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 70,
      "type": "Instance",
      "floors": [
        70
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          29185,
          100890
        ],
        [
          33025,
          103450
        ]
      ]
    },
    {
      "id": 1451,
      "name": "Strike Mission: Kaineng Overlook",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 73,
      "type": "Instance",
      "floors": [
        73
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          25000,
          98100
        ],
        [
          28840,
          100660
        ]
      ]
    },
    {
      "id": 1452,
      "name": "The Echovald Wilds",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Public",
      "floors": [
        69,
        1,
        3,
        2,
        0
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          29185,
          100890
        ],
        [
          33025,
          103450
        ]
      ]
    },
    {
      "id": 1453,
      "name": "Ministry of Security: Main Office",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          25000,
          98100
        ],
        [
          28840,
          100660
        ]
      ]
    },
    {
      "id": 1454,
      "name": "The Scenic Route: Kaineng Docks",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          25000,
          98100
        ],
        [
          28840,
          100660
        ]
      ]
    },
    {
      "id": 1456,
      "name": "Claiming the Isle of Reflection",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 69,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          21319,
          103145
        ],
        [
          23239,
          105705
        ]
      ]
    },
    {
      "id": 1457,
      "name": "Detention Facility",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          33792
        ]
      ],
      "continent_rect": [
        [
          21159,
          100457
        ],
        [
          24999,
          103145
        ]
      ]
    },
    {
      "id": 1458,
      "name": "Aurene's Sanctuary",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          33792
        ]
      ],
      "continent_rect": [
        [
          21159,
          100457
        ],
        [
          24999,
          103145
        ]
      ]
    },
    {
      "id": 1459,
      "name": "Claiming the Isle of Reflection",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 69,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          21319,
          103145
        ],
        [
          23239,
          105705
        ]
      ]
    },
    {
      "id": 1460,
      "name": "Empress Ihn's Court",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          33792
        ]
      ],
      "continent_rect": [
        [
          21159,
          100457
        ],
        [
          24999,
          103145
        ]
      ]
    },
    {
      "id": 1461,
      "name": "Zen Daijun Hideaway",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          33792
        ]
      ],
      "continent_rect": [
        [
          21159,
          100457
        ],
        [
          24999,
          103145
        ]
      ]
    },
    {
      "id": 1462,
      "name": "Isle of Reflection",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          21319,
          103145
        ],
        [
          23239,
          105705
        ]
      ]
    },
    {
      "id": 1463,
      "name": "Claiming the Isle of Reflection",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 69,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -30720
        ],
        [
          24576,
          30720
        ]
      ],
      "continent_rect": [
        [
          21319,
          103145
        ],
        [
          23239,
          105705
        ]
      ]
    },
    {
      "id": 1464,
      "name": "Fallout: Arborstone",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        69,
        1
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -46080,
          -30720
        ],
        [
          46080,
          30720
        ]
      ],
      "continent_rect": [
        [
          29185,
          100890
        ],
        [
          33025,
          103450
        ]
      ]
    },
    {
      "id": 1465,
      "name": "Thousand Seas Pavilion",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 80,
      "type": "Public",
      "floors": [
        80
      ],
      "region_id": 37,
      "region_name": "Cantha",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -15360,
          -15360
        ],
        [
          15360,
          15360
        ]
      ],
      "continent_rect": [
        [
          20900,
          98125
        ],
        [
          22180,
          99405
        ]
      ]
    },
    {
      "id": 1466,
      "name": "A Quiet Celebration—Knut Whitebear's Loft",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 1467,
      "name": "New Friends, New Enemies—The Command Core",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 1468,
      "name": "The Battle for Cragstead—Knut Whitebear's Loft",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 1,
      "region_name": "Shiverpeak Mountains",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -27648,
          -18432
        ],
        [
          27648,
          21504
        ]
      ],
      "continent_rect": [
        [
          52224,
          29696
        ],
        [
          54528,
          31360
        ]
      ]
    },
    {
      "id": 1469,
      "name": "New Friends, New Enemies—Blood Tribune Quarters",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 1470,
      "name": "A Quiet Celebration—Citadel Stockade",
      "min_level": 0,
      "max_level": 0,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 2,
      "region_name": "Ascalon",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -18432,
          -24576
        ],
        [
          18432,
          24576
        ]
      ],
      "continent_rect": [
        [
          56320,
          29952
        ],
        [
          57856,
          32000
        ]
      ]
    },
    {
      "id": 1471,
      "name": "Case Closed—The Dead End",
      "min_level": 1,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 1472,
      "name": "Hard Boiled—The Dead End",
      "min_level": 1,
      "max_level": 80,
      "default_floor": 1,
      "type": "Instance",
      "floors": [
        1,
        2
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 1474,
      "name": "Picking Up the Pieces",
      "min_level": 0,
      "max_level": 80,
      "default_floor": 2,
      "type": "Instance",
      "floors": [
        1,
        3,
        2,
        0
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -21504,
          -21504
        ],
        [
          24576,
          21504
        ]
      ],
      "continent_rect": [
        [
          43008,
          26240
        ],
        [
          44928,
          28032
        ]
      ]
    },
    {
      "id": 1477,
      "name": "The Tower of Nightmares (Private Squad)",
      "min_level": 80,
      "max_level": 80,
      "default_floor": 40,
      "type": "Instance",
      "floors": [
        40
      ],
      "region_id": 4,
      "region_name": "Kryta",
      "continent_id": 1,
      "continent_name": "Tyria",
      "map_rect": [
        [
          -49152,
          -24576
        ],
        [
          49152,
          24576
        ]
      ],
      "continent_rect": [
        [
          41344,
          30336
        ],
        [
          45440,
          32384
        ]
      ]
    }
  ]

  export default value;
